import { templateJoin } from 'bernie-graphql';

    export const flightsFlexibleSearchQuery = templateJoin`
        query FlightsFlexibleSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchPreferences: FlightsSearchPreferencesInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchPreferences: $searchPreferences
    travelerDetails: $travelerDetails
  ) {
    flexibleSearchResponse {
      title
      subTitle
      titleAccessibility
      flexGridType
      loadingStateAccessibility
      dismissGridAccessibility {
        usage
      }
      searchTriggerAction
      analytics {
        priceFillRate
      }
      departureLegend {
        icon {
          description
          id
        }
        labelText
        accessibility
      }
      resultsGrid {
        results {
          ...FlightsFlexSearchHeaderCell
          ...FlightsFlexSearchLegendCell
          ...FlightsFlexSearchResults
        }
      }
      coverageAnalytics {
        ...FlightsAnalytics
      }
      coverageNotValidAnalytics {
        ...FlightsAnalytics
      }
      gridTrigger {
        collapseAnalytics {
          ...FlightsAnalytics
        }
        expandAnalytics {
          ...FlightsAnalytics
        }
      }
    }
  }
}

fragment FlightsFlexSearchResults on FlightsFlexibleSearchResultCell {
  valueText
  labelText
  theme
  summary
  journeyDate
  accessibility {
    highlightDescription
    selectionDescription
  }
  nextSearchCriteria {
    ...FlightsNextJourneyCriteriaValues
  }
  selectAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsNextJourneyCriteriaValues on FlightsNextJourneyCriteriaValues {
  journeyCriteria {
    destination
    departureDate {
      day
      month
      year
    }
    origin
  }
  searchPreferences {
    cabinClass
  }
}

fragment FlightsFlexSearchLegendCell on FlightsFlexibleSearchLegendCell {
  accessibilityMessage {
    usage
  }
  icon {
    description
    id
  }
  valueText
  legendTheme: theme
}

fragment FlightsFlexSearchHeaderCell on FlightsFlexibleSearchHeaderCell {
  labelText
  valueText
  headerTheme: theme
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

    `;

    export const flightsFlexibleDiscoverySearchQuery = templateJoin`
        query FlightsFlexibleDiscoverySearch(
  $context: ContextInput!
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $flightsSearchContext: FlightsSearchContextInput!
  $searchPreferences: FlightsSearchPreferencesInput
) {
  flexibleSearch(
    context: $context
    journeyCriteria: $journeyCriteria
    flightsSearchContext: $flightsSearchContext
    queryState: LOADED
    searchPreferences: $searchPreferences
  ) {
    title
    subTitle
    titleAccessibility
    flexGridType
    loadingStateAccessibility
    dismissGridAccessibility {
      usage
    }
    searchTriggerAction
    analytics {
      priceFillRate
    }
    departureLegend {
      icon {
        description
        id
      }
      labelText
      accessibility
    }
    resultsGrid {
      results {
        ...FlightsFlexSearchHeaderDiscoveryCell
        ...FlightsFlexSearchLegendDiscoveryCell
        ...FlightsFlexSearchResultCell
      }
    }
    title
    coverageAnalytics {
      ...FlightsAnalytics
    }
    coverageNotValidAnalytics {
      ...FlightsAnalytics
    }
    gridTrigger {
      collapseAnalytics {
        ...FlightsAnalytics
      }
      expandAnalytics {
        ...FlightsAnalytics
      }
    }
  }
}

fragment FlightsNextJourneyCriteriaValues on FlightsNextJourneyCriteriaValues {
  journeyCriteria {
    destination
    departureDate {
      day
      month
      year
    }
    origin
  }
  searchPreferences {
    cabinClass
  }
}
fragment FlightsFlexSearchHeaderDiscoveryCell on FlightsFlexibleSearchHeaderCell {
  valueText
  headerTheme: theme
  labelText
}
fragment FlightsFlexSearchLegendDiscoveryCell on FlightsFlexibleSearchLegendCell {
  accessibilityMessage {
    usage
  }
  icon {
    description
    id
  }
  valueText
  legendTheme: theme
  labelText
}
fragment FlightsFlexSearchResultCell on FlightsFlexibleSearchResultCell {
  nextSearchCriteria {
    ...FlightsNextJourneyCriteriaValues
  }
  valueText
  labelText
  theme
  summary
  journeyDate
  accessibility {
    highlightDescription
    selectionDescription
  }
  selectAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

    `;

    export const flightsShoppingPwaFlightInformationResultsQuery = templateJoin`
        query FlightsShoppingPwaFlightInformationResults(
  $context: ContextInput!
  $flightsDetailCriteria: FlightsDetailCriteriaInput!
  $queryState: FlightsQueryState
  $virtualAgentContext: VirtualAgentContextInput
) {
  flightsDetail(
    context: $context
    flightsDetailCriteria: $flightsDetailCriteria
    queryState: $queryState
    virtualAgentContext: $virtualAgentContext
  ) {
    gaiaId
    journeyContinuationId
    baseOfferAncillaryID
    analytics {
      footerOnViewedAnalytics {
        ...FlightsAnalytics
      }
      onLoadAnalyticsList {
        ...FlightsAnalytics
      }
    }
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalytics
        }
      }
    }
    flightsOpinionLab {
      ... on FlightsActionAndLabel {
        label
        selectAction {
          ...FlightsActionInformationLoaded
        }
      }
    }
    pageTitle {
      ... on FlightsPageTitle {
        title {
          ...FlightsResponsiveMessage
        }
        pageAccessibility
      }
    }
    messagingCards {
      __typename
      ...FlightsIconPlacardInformationLoaded
      ...FlightsImagePlacardInformationLoaded
      ...FlightsMarkPlacardInformationLoaded
    }
    partnerLoyaltyEarnMessage {
      ...FlightsMarkPlacard
    }
    banners {
      ...FlightsIconPlacardInformationLoaded
    }
    freeCancellation {
      ...FlightsImagePlacardInformationLoaded
    }
    flightsSelectedJourneyReview {
      __typename
      ... on LoadedFlightsSelectedJourneyReview {
        flightsJourneyInformation {
          details {
            ...FlightsToggleInformationLoaded
          }
          flightJourneyDetails {
            journeySections {
              journeyConnectionInformation {
                __typename
                ... on AdditionalInformation {
                  durationAndStop
                  nextFlightOriginAirportInfo {
                    icon {
                      ...IconInformationLoaded
                    }
                    label
                    theme
                    accessibility
                  }
                }
                ... on FlightsConnectionInformation {
                  flightsConnection {
                    aircraftModel
                    airlineInfo
                    cabinClassAndBookingCode
                    connectionArrival {
                      ...CoordinateInformationInformationLoaded
                    }
                    connectionDeparture {
                      ...CoordinateInformationInformationLoaded
                    }
                    duration
                    journeyAmenities {
                      ...FlightsInformationJourneyAmenities
                    }
                    operatedBy
                  }
                }
              }
            }
            journeyAmenities {
              icon {
                ...IconInformationLoaded
              }
              label
              accessibility
              value
              theme
              displayAnalytics {
                ...FlightsAnalytics
              }
            }
          }
        }
        flightsJourneyHeaders {
          ...FlightsJourneyHeaders
        }
        flightsJourneySummary {
          __typename
          heading {
            ...FlightsMessageAndAccessibilityInformationLoaded
          }
          differentDayArrival {
            ...FlightsMessageAndAccessibilityInformationLoaded
          }
          basicFlightDetails {
            ...FlightsMessageAndAccessibilityInformationLoaded
          }
          ... on FlightsBargainJourneySummary {
            arrivalDayInformation
          }
          ... on LoadedFlightsStandardJourneySummary {
            journeyAmenities {
              ...FlightsInformationJourneyAmenities
            }
          }
        }
        journeyHighlights {
          flightsJourneyHeaders {
            ...FlightsJourneyHeaders
          }
          flightsJourneySummary {
            __typename
            heading {
              ...FlightsMessageAndAccessibilityInformationLoaded
            }
            differentDayArrival {
              ...FlightsMessageAndAccessibilityInformationLoaded
            }
            basicFlightDetails {
              ...FlightsMessageAndAccessibilityInformationLoaded
            }
            ... on FlightsBargainJourneySummary {
              arrivalDayInformation
            }
          }
        }
        onViewedAnalytics {
          ...FlightsAnalytics
        }
        changeFlight {
          ...FlightsActionInformationLoaded
        }
        changeFlightDialog {
          header
          title
          animation
          actions {
            analytics {
              ...FlightsAnalytics
            }
            analyticsList {
              ...FlightsAnalytics
            }
            displayAction
            displayType
            accessibilityMessage
          }
          displayedAnalytics {
            ...FlightsAnalytics
          }
        }
        fareDetails {
          fareSummary {
            __typename
            message
            title
            flightsSelectedJourneyAvailableFaresInformation {
              ...FlightsSelectedJourneyAvailableFares
            }
            details {
              ...FlightsActionInformationLoaded
            }
            flightsFareNudgeMessage {
              ...FlightsIconAndLabelLoaded
            }
            upsellNudgingFeatureEnabled
          }
          defaultBaggageInformation {
            ...FlightsBaggageInformation
          }
          fareSeatMapInformation {
            ...FareSeatMapInformation
          }
          changeAndCancellationFees {
            ...FlightsChangeAndCancellationFees
          }
        }
        flightsJourneyPolicies {
          ...FlightsInformationTextSectionLoaded
        }
        journeyInformation {
          ...JourneyInformation
        }
        upsellNudgingFeatureEnabled
      }
    }
    priceSummary {
      ...FlightsLoadedPriceSummary
    }
    separateTicketBanner {
      ...FlightsIconPlacardInformationLoaded
    }
    serverErrorMessaging {
      ...FlightsInformationServerErrorMessaging
    }
    dynamicElementsGroups {
      ancillaryId
      identifier
      dynamicElements {
        flightsJourneyDetailsDynamicElements {
          fareName
          journeyPartsDynamicElements {
            cabinClassAndBookingCode
          }
          fareSeatMapDynamicElement {
            onSelectAnalytics {
              ...FlightsAnalytics
            }
            flightLegsDetails {
              ...FareSeatMapAvailableFlightLegsDetails
            }
          }
          selectedSeatDetails {
            ...FlightsSelectedSeatDetail
          }
          title
          message
          details {
            ...FlightsActionInformationLoaded
          }
          flightsFareNudgeMessage {
            ...FlightsIconAndLabelLoaded
          }
          fareChangeAction {
            ...FlightsActionInformationLoaded
          }
        }
        dynamicElementsGroupTrackEventAnalytics {
          analyticsList {
            linkName
            referrerId
          }
          stringifiedAllFlightProducts
        }
        ... on FlightsInformationDynamicElements {
          airOfferToken
          priceSummary {
            ...FlightsLoadedPriceSummary
          }
          totalPrice
          fareChoiceInformationDynamicElement {
            farePricePerPerson
          }
        }
      }
    }
    multiItemDynamicCrossSellPrimer {
      multiItemSearchContext {
        ...MultiItemFlightsSearchContext
      }
      multiItemSelectedFlightProducts {
        ...MultiItemFlightNaturalKey
      }
    }
    flightsInformationPriceMatchPromise {
      surveyElementId
      card {
        ...FlightsMessagingCardFISPlacardFragment
      }
    }
    smartShoppingExperienceEligibility
  }
}

fragment FlightsJourneyHeaders on FlightsJourneyHeaders {
  __typename
  flightsJourneySubheading
  flightsJourneySubheadingMark {
    description
    id
    size
    token
    url {
      relativePath
      value
    }
  }
  heading
}

fragment FlightsChangeAndCancellationFees on FlightsChangeAndCancellationFees {
  heading
  changeAndCancellationDetails {
    ...FlightsLabelAndValue
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsLabelAndValue on FlightsLabelAndValue {
  label
  value
  accessibilityMessage
}

fragment FareSeatMapInformation on FareSeatMapInformation {
  details {
    ...FlightsActionInformationLoaded
  }
  fareSeatMapViewDetails {
    ...FareSeatMapViewDetails
  }
  selectedSeatDetails {
    ...FlightsSelectedSeatDetail
  }
  errorMessages {
    ...FlightsSeatSelectionErrorMessage
  }
  message
  title
  ancillaryId
  enableSeatSelection
  errorMessage
  skeletonCount
}

fragment FlightsSeatSelectionErrorMessage on FlightsSeatSelectionErrorMessage {
  id
  message
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsSelectedSeatDetail on FlightsSelectedSeatDetail {
  flightInformation
  travelerSeatsInformation
}

fragment FareSeatMapViewDetails on FareSeatMapViewDetails {
  dismissSeatMapDialog {
    ...FlightsActionableInformationIconLoaded
  }
  errorMessage {
    ...FlightsIconPlacardInformationLoaded
  }
  fareSeatMapLegendsInformation {
    ...FareSeatMapLegendsInformation
  }
  flightLegsDetails {
    ...FareSeatMapAvailableFlightLegsDetails
  }
  onLoadAccessibilityMessage
  seatMapAlertDialog {
    ...FareSeatMapAlertDialog
  }
  seatMapDialogAnalyticsList {
    ...FlightsAnalytics
  }
  title
}

fragment FareSeatMapAlertDialog on FareSeatMapAlertDialog {
  __typename
  id
  alert {
    __typename
    actions {
      ...FlightsActionInformationLoaded
    }
    animation
    displayedAnalytics {
      ...FlightsAnalytics
    }
    message
    title
  }
}

fragment FareSeatMapAvailableFlightLegsDetails on FareSeatMapAvailableFlightLegsDetails {
  __typename
  flightLegSelectionList {
    ...FareSeatMapAvailableFlightLegSelection
  }
  offerIdentifier
  onViewedAnalytics {
    ...FlightsAnalytics
  }
  pricingConstruct
}

fragment FareSeatMapAvailableFlightLegSelection on FareSeatMapAvailableFlightLegSelection {
  __typename
  errorAnalytics {
    ...FlightsAnalytics
  }
  identifier
  isSelected
  seatMapLegSummary {
    ...FlightsSeatMapLegSummary
  }
  seatSegment {
    ...FlightsSeatSegmentLoaded
  }
  selectedCard {
    ...FlightsIconPlacardInformationLoaded
  }
  unselectedCard {
    ...FlightsIconPlacardInformationLoaded
  }
}

fragment FlightsSeatMapTotalDetails on FlightsSeatMapTotalDetails {
  __typename
  label {
    ...FlightsResponsiveMessage
  }
  noSeatSelected
  seatDelimiter
  seatsSelectedMessage {
    ...FlightsSimpleLocalizationTemplate
  }
  selectedSeats {
    ...FlightsSeatMapSeatDetails
  }
  totalPrice {
    ...FlightsSimpleLocalizationTemplate
  }
}

fragment FlightsResponsiveMessage on FlightsResponsiveMessage {
  __typename
  longMessage
  shortMessage
}

fragment FlightsSeatMapLegSummaryActionType on FlightsSeatMapLegSummaryActionType {
  __typename
  analyticsList {
    ...FlightsAnalytics
  }
  id
}

fragment FlightsSeatMapLegSummary on FlightsSeatMapLegSummary {
  __typename
  buttonAction {
    ...FlightsActionInformationLoaded
  }
  buttonActionTypes {
    ...FlightsSeatMapLegSummaryActionType
  }
  seatTotalDetails {
    ...FlightsSeatMapTotalDetails
  }
  travelerSummary {
    __typename
    title {
      ...FlightsResponsiveMessage
    }
    travelers {
      __typename
      action {
        ... on FlightsActionAndLabel {
          __typename
          label
          selectAction {
            ...FlightsActionInformationLoaded
          }
        }
      }
      id
      seatDetails {
        ...FlightsSeatMapSeatDetails
      }
    }
  }
}

fragment FlightsSeatMapSeatDetails on FlightsSeatMapSeatDetails {
  __typename
  assignedSeat
  id
  price {
    __typename
    amount
    default
    selected {
      ...FlightsSimpleLocalizationTemplate
    }
  }
}

fragment FlightsSimpleLocalizationTemplate on FlightsSimpleLocalizationTemplate {
  __typename
  initialValue
  template
  tokens
}

fragment FlightsSeatSegmentLoaded on SeatSegment {
  fareBasisCode
  identifier
  operatingCarrierCode
}

fragment FareSeatMapLegendsInformation on FareSeatMapLegendsInformation {
  __typename
  accessibilityMessage
  dismissSeatMapLegends {
    ...FlightsAnalytics
  }
  legendDetails {
    ...FlightsSeatMapLegends
  }
  viewLegendButton {
    ...FlightsActionableInformationIconLoaded
  }
}

fragment ClientAnalytics on ClientSideAnalytics {
  __typename
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment clientAction on FlightsClientAction {
  accessibility
  analyticsList {
    ...ClientAnalytics
  }
}

fragment FlightsSeatMapLegends on FlightsSeatMapLegends {
  __typename
  close {
    clientAction {
      ...clientAction
    }
    primary
    style
    accessibility
    disabled
    icon {
      ...IconInformationLoaded
    }
  }
  legendVariants {
    ...FlightsSeatMapLegendVariant
  }
  title
}

fragment FlightsSeatMapLegendVariant on FlightsSeatMapLegendVariant {
  __typename
  legendCard {
    __typename
    text
    accessibilityMessage
    icon {
      ...IconInformationLoaded
    }
  }
  title
}

fragment MultiItemFlightsSearchContext on MultiItemSearchContext {
  flights {
    primary {
      journeyCriterias {
        origin
        destination
        departureDate {
          day
          month
          year
        }
      }
      searchPreferences {
        advancedFilters
        airline
        cabinClass
      }
      travelers {
        age
        type
      }
      tripType
    }
  }
}

fragment MultiItemFlightNaturalKey on MultiItemSelectedFlightProducts {
  flights {
    offerToken
    productTokens
    travelers {
      age
      type
    }
  }
}

fragment FlightsInformationJourneyAmenities on FlightsJourneyAmenities {
  accessibilityMessage
  amenities {
    ...FlightsIconAndLabelLoaded
  }
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsSelectedJourneyAvailableFares on FlightsSelectedJourneyAvailableFares {
  __typename
  fareChoiceInformation {
    __typename
    accessibleHeading
    heading {
      ...FlightsResponsiveMessage
    }
    message
    nextFareChoiceAccessibilityMessage
    previousFareChoiceAccessibilityMessage
    tripTypePerTraveler
    displayAnalytics {
      ...FlightsAnalytics
    }
    scrollAnalytics {
      ...FlightsAnalytics
    }
    errorAnalytics {
      ...FlightsAnalytics
    }
    convertAnalytics {
      ...FlightsAnalytics
    }
    fares {
      __typename
      name
      cabinClass
      cabinClassAndBookingCodes
      accessibilityMessage
      safetyLocationAccessibilityMessage
      selectFareActionAltText
      journeyFareTotalPrice
      chooseFareAction {
        displayAction
        accessibilityMessage
        type
      }
      loyaltyPointsOption {
        ...FlightsLoyaltyPointsOption
      }
      formattedPrice {
        completeText
        items {
          text
          styles
        }
      }
      totalPrice
      identifier
      selected
      clickEventAnalytics {
        ...FlightsAnalytics
      }
      fareScrollAnalytics {
        ...FlightsAnalytics
      }
      collapsedRules {
        ...FlightsInformationJourneyAmenities
      }
      expandedRules {
        label
        rules {
          ...FlightsInformationJourneyAmenities
        }
      }
      amenityHierarchyRules {
        label
        rules {
          ...FlightsInformationJourneyAmenities
        }
      }
      baggageFeesInformation {
        ...FlightsBaggageInformation
      }
      showMoreAmenitiesToggle {
        ...FlightsToggleInformationLoaded
      }
      selectFareAction {
        ...FlightsActionInformationLoaded
      }
      recommendation {
        text
        type
      }
      amenityRules {
        __typename
        itemsDefaultDisplayCount
        amenities {
          __typename
          accessibility
          icon {
            ...IconInformationLoaded
          }
          label
          theme
          displayAnalytics {
            ...FlightsAnalytics
          }
        }
      }
      upsellOfferToken
      badges {
        accessibility
        text
        theme
      }
      priceLockup {
        accessibilityPrice
        lockupPrice
        strikeThroughPrice
        priceSubtextFirst
      }
      ... on FlightsPMPJourneyFare {
        isPmpSelected
        priceLockupWithPMP {
          accessibilityPrice
          lockupPrice
          strikeThroughPrice
          priceSubtextFirst
        }
        selectFareActionWithPMP {
          ...FlightsActionInformationLoaded
        }
        priceMatchPromiseSelectionCardSection {
          ...PriceMatchPromiseSelectionCardFragment
        }
        priceMatchPromiseSelectedCardSection {
          ...PriceMatchPromiseSelectedCardFragment
        }
      }
    }
    defaultBaggageInformation {
      ...FlightsBaggageInformation
    }
    sustainabilityInformation {
      ...FlightsIconLoadedPhrases
    }
    dialogs {
      ...FaresDialogsFIS
    }
  }
  dismissDetailedJourneyInformation {
    ...FlightsActionableInformationIconLoaded
  }
  openAccessibility
  flightsJourneyHeaders {
    ...FlightsJourneyHeaders
  }
}

fragment FlightsLoadedPriceSummary on FlightsLoadedPriceSummary {
  __typename
  bookWithAirlinesDialog {
    ...FlightsDialogPresentation
  }
  breakdown {
    ...FlightsPriceSummaryGroupLoaded
  }
  buttonAction {
    ...FlightsActionInformationLoaded
  }
  dismiss {
    ...FlightsActionableInformationIconLoaded
  }
  policies {
    ...FlightsInformationTextSectionLoaded
  }
  title
  tripTotalLabel
  totals {
    ...FlightsPriceSummaryGroupLoaded
  }
  tripTotalDetails {
    ...FlightsLoadedPriceSummaryTripTotalItem
  }
  viewPriceSummary {
    ...FlightsActionInformationLoaded
  }
  creditShoppingRedirectMessaging
  creditShoppingRedirectAction {
    ...FlightsActionInformationLoaded
  }
  urgencyMessage {
    ...EGDSBadgeFragment
  }
  displayAnalytics {
    ...ClientAnalytics
  }
}

fragment EGDSBadgeFragment on EGDSBadge {
  __typename
  accessibility
  text
  theme
}

fragment FlightsInformationServerErrorMessaging on FlightsActionableErrorMessaging {
  __typename
  action {
    ...FlightsActionInformationLoaded
  }
  icon {
    ...IconInformationLoaded
  }
  message
  title
}

fragment FlightsMessageAndAccessibilityInformationLoaded on FlightsMessageAndAccessibility {
  __typename
  text
  accessibilityMessage
}

fragment FlightsLoyaltyPointsOption on FlightsLoyaltyPointsOption {
  overageAmount
  strikeThroughFormattedPoints
  leadingCaption
  formattedPoints
  isPointsFirst
  isStrikeThroughFirst
  accessibility
}

fragment FlightsToggleInformationLoaded on FlightsToggle {
  collapseActionable {
    ...TogglePhaseInformationLoaded
  }
  expandActionable {
    ...TogglePhaseInformationLoaded
  }
  expanded
}

fragment IconInformationLoaded on Icon {
  __typename
  description
  id
  size
  withBackground
  theme
}

fragment TogglePhaseInformationLoaded on TogglePhase {
  accessibilityMessage
  action
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconInformationLoaded
  }
}

fragment CoordinateInformationInformationLoaded on CoordinateInformation {
  icon {
    ...IconInformationLoaded
  }
  flightDetailsWarningInfo {
    icon {
      ...IconInformationLoaded
    }
    label
    theme
    accessibility
    subLabel
  }
  subtitle
  titleAndAccessibilityMessage {
    accessibilityMessage
    text
  }
}

fragment FlightsMarkPlacard on FlightsMarkPlacard {
  heading
  message
  displayType
  mark {
    description
    id
  }
  stylisedText {
    ...EGDSSpannableTextFragmentInformation
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsMarkPlacardInformationLoaded on FlightsMarkPlacard {
  heading
  message
  displayType
  mark {
    description
    id
  }
  actions {
    ...FlightsActionInformationLoaded
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsImagePlacardInformationLoaded on FlightsImagePlacard {
  __typename
  image {
    url
    description
  }
  heading
  message
  actions {
    ...FlightsActionInformationLoaded
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsIconPlacardInformationLoaded on FlightsIconPlacard {
  heading
  message
  displayType
  icon {
    ...IconInformationLoaded
  }
  actions {
    ...FlightsActionInformationLoaded
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
}

fragment EGDSSpannableTextFragmentInformation on EGDSSpannableText {
  __typename
  text
  contents {
    __typename
    ... on EGDSHeading {
      text
      headingType
    }
    ... on EGDSParagraph {
      text
      style
    }
    ... on EGDSIconText {
      text
      icon {
        id
        size
      }
    }
    ... on EGDSStandardLink {
      text
      action {
        __typename
        accessibility
        target
        resource {
          __typename
          value
        }
        analytics {
          __typename
          linkName
          referrerId
        }
      }
    }
    ... on EGDSPlainText {
      text
    }
    ... on EGDSStylizedText {
      decorative
      text
      theme
      weight
      stylizedSize: size
    }
  }
  inlineContent {
    __typename
    ... on EGDSHeading {
      text
      headingType
    }
    ... on EGDSGraphicText {
      ...EGDSGraphicTextFragmentInformation
    }
    ... on EGDSStandardLink {
      text
      action {
        __typename
        accessibility
        target
        resource {
          __typename
          value
        }
        analytics {
          __typename
          linkName
          referrerId
        }
      }
    }
    ... on EGDSPlainText {
      text
    }
    ... on EGDSStylizedText {
      decorative
      text
      theme
      weight
      stylizedSize: size
    }
  }
}

fragment MarkFragments on Mark {
  __typename
  description
  id
  markSize: size
  url {
    ... on HttpURI {
      __typename
      relativePath
      value
    }
  }
}

fragment FlightsActionInformationLoaded on FlightsAction {
  __typename
  accessibilityMessage
  accessibilityCheckoutMessage
  analytics {
    ...FlightsAnalytics
  }
  analyticsList {
    ...FlightsAnalytics
  }
  displayAction
  displayType
  enable
  relativePackageableURI {
    relativePath
    value
  }
  relativeURI {
    relativePath
    value
  }
  type
  displayAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment FlightsPriceSummaryGroupLoaded on FlightsPriceSummaryGroup {
  accessibilityMessage
  entries {
    ...FlightsPriceSummaryLoadedItem
  }
  title {
    ...FlightsPriceSummaryLoadedItem
  }
}

fragment FlightsPriceSummaryItemDetailsLoaded on FlightsPriceSummaryItemDetails {
  action {
    ...FlightsActionableInformationIconLoaded
  }
  breakdown {
    ...FlightsPriceSummaryItemGroupLoaded
  }
}

fragment FlightsPriceSummaryItemGroupLoaded on FlightsPriceSummaryItemGroup {
  title
  entries {
    ... on FlightsPriceSummaryItem {
      label
      price
    }
  }
  error {
    ...FlightsPriceSummaryItemErrorLoaded
  }
  action {
    ...FlightsActionInformationLoaded
  }
}

fragment FlightsPriceSummaryItemErrorLoaded on FlightsPriceSummaryItemError {
  message
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsPriceSummaryLoadedItem on FlightsPriceSummaryItem {
  label
  price
  roundedPrice
  details {
    ...FlightsPriceSummaryItemDetailsLoaded
  }
  loyaltyPoints
}

fragment FlightsActionableInformationIconLoaded on FlightsActionableIcon {
  __typename
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconInformationLoaded
  }
  type
  displayText
  accessibilityMessage
}

fragment FlightsInformationTextSectionLoaded on FlightsTextSection {
  displayAction {
    ...FlightsToggleInformationLoaded
  }
  heading
  messages {
    ...FlightsInformationLoadedPhrase
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
  displayAnalyticsList {
    ...FlightsAnalytics
  }
}

fragment FlightsInformationLoadedPhrase on FlightsPhrase {
  __typename
  completeText
  delimeter
  items {
    __typename
    text
    styles
    ... on FlightsPhraseLinkNode {
      accessibility
      analytics {
        ...FlightsAnalytics
      }
      displayAnalytics {
        ...FlightsAnalytics
      }
      scrollAnalytics {
        ...FlightsAnalytics
      }
      link
      icon
    }
  }
}

fragment FlightsLoadedPriceSummaryTripTotalItem on FlightsPriceSummaryTripTotalItem {
  messages {
    heading
    messages {
      completeText
      size
    }
  }
  ratesCurrencyMessage
  ratesCurrencyText
  tripTotal {
    ...FlightsPriceSummaryLoadedItem
  }
}

fragment FlightsBaggageInformation on FlightsBaggageInformation {
  label
  defaultBagSelectionMessage
  bagFeesMoreInfo {
    ...FlightsInformationLoadedPhrase
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
  displayDetailsAction
  dismissAction
  details {
    ...FlightsBaggageInformationDetail
  }
  displayAnalyticsItems {
    ...FlightsAnalytics
  }
}

fragment FlightsBaggageInformationDetail on FlightBaggageInformationDetail {
  topic
  baggageDetail
}

fragment JourneyInformation on JourneyInformation {
  destinationAirportCode
  originAirportCode
  tripType
}

fragment FlightsDialogPresentation on FlightsDialogPresentation {
  message
  title
  animation
  actions {
    analyticsList {
      ...FlightsAnalytics
    }
    displayAction
    displayType
    accessibilityMessage
    type
    relativeURI {
      relativePath
      value
    }
  }
  displayedAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsIconLoadedPhrases on FlightsIconPhrases {
  text {
    ...FlightsInformationLoadedPhrase
  }
  icon {
    ...IconInformationLoaded
  }
}

fragment FlightsIconAndLabelLoaded on FlightsIconAndLabel {
  icon {
    ...IconInformationLoaded
  }
  label
  subLabel
  accessibility
  value
  theme
  displayAnalytics {
    ...FlightsAnalytics
  }
  subText {
    ... on EGDSStylizedText {
        decorative
        text
        theme
        weight
        size
    }
  }
}

fragment FlightsMessagingCardFISPlacardFragment on FlightsMessagingCardPlacard {
  messagingCard {
    primary
    secondaries
    graphic {
      ...EgdsGraphicIllustrationFragment
    }
  }
  button {
    ...FlightsActionButtonFragment
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsDialogTriggerActionFIS on FlightsDialogTriggerAction {
  __typename
  dialog {
    ...EGDSActionDialogFragment
  }
  analyticsList {
    __typename
    ...ClientAnalytics
  }
  dialogContents {
    __typename
    ... on EGDSParagraph {
      text
    }
  }
}

fragment EGDSActionDialogFragment on EGDSActionDialog {
  __typename
  footer {
    ...EGDSActionDialogFooter
  }
}

fragment EGDSActionDialogFooter on EGDSDialogFooter {
  __typename
  buttons {
    ...UITertiaryButtonFragment
    ... on FlightsActionButton {
      __typename
      style
      primary
      clientAction {
        analyticsList {
          ...ClientAnalytics
        }
        ... on FlightsRemovePriceMatchPromiseAction {
          journeyContinuationId
        }
      }
    }
  }
}

fragment FlightsActionButtonFragment on FlightsActionButton {
  __typename
  accessibility
  clientAction {
    ...FlightsDialogTriggerActionFIS
  }
  disabled
  egdsElementId
  icon {
    ...IconInformationLoaded
  }
  primary
  style
  action {
    __typename
    accessibility
    analytics {
      ...ClientAnalytics
    }
  }
}

fragment EgdsGraphicIllustrationFragment on Illustration {
  link: url
  id
  description
}

fragment UITertiaryButtonFragment on UITertiaryButton {
  __typename
  disabled
  primary
  action {
    ... on UIFlightAction {
      __typename
      analytics {
        ...ClientAnalytics
      }
    }
  }
}

fragment FlightsDialogTriggerFIS on FlightsDialogTrigger {
  dialogAction
  dialogId
  trigger {
    __typename
    ...FlightsActionButtonFragment
    ...FlightsActionLinkFIS
  }
}

fragment FaresDialogsFIS on FlightsDialog {
  dialog {
    __typename
    ...EGDSDialogFIS
  }
  dialogContent: content {
    __typename
    ...EgdsElementFragmentFIS
    ... on FlightsDialogTrigger {
      ...FlightsDialogTriggerFIS
    }
  }
  dialogId
}

fragment EGDSDialogFIS on EGDSDialog {
  closeAnalytics {
    ...ClientAnalytics
  }
  ...EGDSFullScreenDialogFragmentFIS
  ... on EGDSActionDialog {
    __typename
    footer {
      buttons {
        ...FlightsActionButtonFragment
        ...FlightsDialogTriggerFIS
      }
    }
  }
}

fragment PriceMatchPromiseSelectionCardFragment on PriceMatchPromiseSelectionCardSection {
  header
  description
  price
  icon {
    ...IconInformationLoaded
  }
  toggleCheckbox {
    ...FlightsActionCheckboxFragmentFIS
  }
  onDisplayAnalytics {
    ...FlightsAnalytics
  }
}

fragment PriceMatchPromiseSelectedCardFragment on PriceMatchPromiseSelectedCardSection {
  header
  description
  icon {
    ...IconInformationLoaded
  }
  removeActionLink {
    ...FlightsActionLinkFIS
  }
  onDisplayAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsActionCheckboxFragmentFIS on FlightsActionCheckbox {
  label {
    ...EgdsTextFragmentFIS
  }
}

fragment FlightsActionLinkFIS on FlightsActionLink {
  clientAction {
    ...clientAction
    ... on FlightsCreditSelectionAction {
      originalBookingId
    }
    ... on FlightsResourceLinkAction {
      resource {
        ... on HttpURI {
          relativePath
          value
        }
      }
    }
  }
  disabled
  primary
  icon {
    ...IconInformationLoaded
  }
}

fragment EgdsElementFragmentFIS on EGDSElement {
  __typename
  ... on Illustration {
    ...EgdsGraphicIllustrationFragment
  }
  ... on EGDSText {
    ...EgdsTextFragmentFIS
  }
  ... on UIMessagingCard {
    primary
    secondaries
    graphic {
      ...EgdsGraphicIllustrationFragment
    }
  }

  ... on EGDSBulletedList {
    listItems {
      __typename
      text
    }
  }
}

fragment EgdsTextFragmentFIS on EGDSText {
  __typename
  ... on EGDSGraphicText {
    ...EGDSGraphicTextFragmentInformation
  }
  ... on EGDSHeading {
    text
    headingType
  }
  ... on EGDSParagraph {
    text
    style
  }
  ... on EGDSIconText {
    text
    icon {
      id
    }
  }
  ... on EGDSStandardLink {
    text
    action {
      __typename
      accessibility
      target
      resource {
        __typename
        value
      }
      analytics {
        ...ClientAnalytics
      }
    }
  }
  ... on EGDSSpannableText {
    ...EGDSSpannableTextFragmentInformation
  }
}

fragment EGDSFullScreenDialogFragmentFIS on EGDSFullScreenDialog {
  ... on EGDSFullScreenDialog {
    toolbar {
      title
      closeText
    }
  }
}

fragment EGDSGraphicTextFragmentInformation on EGDSGraphicText {
  textGraphic: graphic {
    ...UIGraphicFragmentInformation
  }
  text
}

fragment UIGraphicFragmentInformation on UIGraphic {
  ...IconInformationLoaded
  ...MarkFragments
  ...EgdsGraphicIllustrationFragment
}

    `;

    export const flightsShoppingPwaFlightInformationResultsLoadingQuery = templateJoin`
        query FlightsShoppingPwaFlightInformationResultsLoading(
  $context: ContextInput!
  $flightsDetailCriteria: FlightsDetailCriteriaInput
  $flightsDetailComponentsCriteria: FlightsDetailComponentsCriteriaInput
  $queryState: FlightsQueryState
) {
  flightsDetail(
    context: $context
    flightsDetailCriteria: $flightsDetailCriteria
    flightsDetailComponentsCriteria: $flightsDetailComponentsCriteria
    queryState: $queryState
  ) {
    gaiaIds
    additionalShopping
    journeyStartEndDates {
      startDate
      endDate
    }
    journeyContinuationId
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalytics
        }
      }
    }
    pageTitle {
      ... on FlightsPageTitle {
        title {
          longMessage
          shortMessage
        }
        pageAccessibility
      }
    }
    freeCancellation {
      ...FlightsImagePlacardInformationLoading
    }
    flightsSelectedJourneyReview {
      ... on LoadingFlightsSelectedJourneyReview {
        journeyInformation {
          tripType
        }
        flightsJourneyHeaders {
          heading
          flightsJourneySubheadingMark {
            description
            id
            size
            token
            url {
              relativePath
              value
            }
          }
          flightsJourneySubheading
        }
        flightsJourneySummary {
          __typename
          heading {
            ...FlightsMessageAndAccessibilityInformationLoading
          }
          differentDayArrival {
            ...FlightsMessageAndAccessibilityInformationLoading
          }
          basicFlightDetails {
            ...FlightsMessageAndAccessibilityInformationLoading
          }
          ... on LoadingFlightsStandardJourneySummary {
            skeletonCount
          }
          ... on FlightsBargainJourneySummary {
            arrivalDayInformation
          }
        }
        journeyHighlights {
          flightsJourneyHeaders {
            heading
            flightsJourneySubheadingMark {
              description
              id
              size
              token
              url {
                relativePath
                value
              }
            }
            flightsJourneySubheading
          }
          flightsJourneySummary {
            __typename
            heading {
              ...FlightsMessageAndAccessibilityInformationLoading
            }
            differentDayArrival {
              ...FlightsMessageAndAccessibilityInformationLoading
            }
            basicFlightDetails {
              ...FlightsMessageAndAccessibilityInformationLoading
            }
            ... on LoadingFlightsStandardJourneySummary {
              skeletonCount
            }
            ... on FlightsBargainJourneySummary {
              arrivalDayInformation
            }
          }
        }
        fareSummarySkeletonCount
        changeFlight {
          ...FlightsActionInformationLoading
        }
        changeFlightDialog {
          header
          title
          animation
          actions {
            analytics {
              ...FlightsAnalytics
            }
            analyticsList {
              ...FlightsAnalytics
            }
            displayAction
            displayType
            accessibilityMessage
          }
          displayedAnalytics {
            ...FlightsAnalytics
          }
        }
        upsellNudgingFeatureEnabled
      }
    }
    priceSummary {
      __typename
      ... on FlightsLoadingPriceSummary {
        title
        skeletonCount
        tripTotalLabel
        buttonAction {
          ...FlightsActionInformationLoading
        }
      }
    }
    serverErrorMessaging {
      ...FlightsInformationLoadingServerErrorMessaging
    }
    stepIndicator {
      ...FlightsInformationStepIndicator
    }
    flightsSupportedAncillaries {
      ...FlightsInformationSupportedAncillaryInfo
    }
  }
}

fragment FlightsInformationSupportedAncillaryInfo on FlightsSupportedAncillaryInfo {
  journeyContinuationId
  ancillaryTypes
}

fragment FlightsInformationStepIndicator on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalytics
  }
  journeyContinuationId
}

fragment FlightsInformationLoadingServerErrorMessaging on FlightsActionableErrorMessaging {
  __typename
  action {
    ...FlightsActionInformationLoading
  }
  icon {
    ...IconInformationLoading
  }
  message
  title
}

fragment IconInformationLoading on Icon {
  id
}

fragment FlightsMessageAndAccessibilityInformationLoading on FlightsMessageAndAccessibility {
  text
  accessibilityMessage
}

fragment FlightsImagePlacardInformationLoading on FlightsImagePlacard {
  __typename
  image {
    url
    description
  }
  heading
  message
}

fragment FlightsActionInformationLoading on FlightsAction {
  accessibilityMessage
  analyticsList {
    ...FlightsAnalytics
  }
  displayAction
  displayType
  enable
  relativePackageableURI {
    relativePath
    value
  }
  relativeURI {
    relativePath
    value
  }
  type
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

    `;

    export const flightsShoppingPwaSeatSelectionQuery = templateJoin`
        query FlightsShoppingPwaSeatSelection(
  $context: ContextInput!
  $flightsDetailCriteria: FlightsDetailCriteriaInput!
  $queryState: FlightsQueryState
) {
  flightsDetail(context: $context, flightsDetailCriteria: $flightsDetailCriteria, queryState: $queryState) {
    flightsSelectedJourneyReview {
      __typename
      ... on LoadedFlightsSelectedJourneyReview {
        fareDetails {
          fareSeatMapInformation {
            ...FareSeatMapInfo
          }
        }
      }
    }
    priceSummary {
      ...FlightsLoadedPriceSummary
    }
    baseOfferAncillaryID
    dynamicElementsGroups {
      ancillaryId
      identifier
      dynamicElements {
        flightsJourneyDetailsDynamicElements {
          fareName
          journeyPartsDynamicElements {
            cabinClassAndBookingCode
          }
          fareSeatMapDynamicElement {
            onSelectAnalytics {
              ...FlightsAnalytics
            }
            flightLegsDetails {
              ...FareSeatMapAvailableFlightLegsDetails
            }
          }
          selectedSeatDetails {
            ...FlightsSelectedSeatDetail
          }
          title
          message
          details {
            ...FlightsActionInformationLoaded
          }
        }
        dynamicElementsGroupTrackEventAnalytics {
          analyticsList {
            linkName
            referrerId
          }
          stringifiedAllFlightProducts
        }
        ... on FlightsInformationDynamicElements {
          priceSummary {
            ...FlightsLoadedPriceSummary
          }
          totalPrice
          fareChoiceInformationDynamicElement {
            farePricePerPerson
          }
        }
      }
    }
  }
}

fragment FareSeatMapInfo on FareSeatMapInformation {
  details {
    ...FlightsActionInformationLoaded
  }
  fareSeatMapViewDetails {
    ...FareSeatMapViewDetails
  }
  selectedSeatDetails {
    ...FlightsSelectedSeatDetail
  }
  errorMessages {
    ...FlightsSeatSelectionErrorMessage
  }
  message
  title
  ancillaryId
  enableSeatSelection
  skeletonCount
}

fragment FlightsSeatSelectionErrorMessage on FlightsSeatSelectionErrorMessage {
  id
  message
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsSelectedSeatDetail on FlightsSelectedSeatDetail {
  flightInformation
  travelerSeatsInformation
}

fragment FareSeatMapViewDetails on FareSeatMapViewDetails {
  dismissSeatMapDialog {
    ...FlightsActionableInformationIconLoaded
  }
  errorMessage {
    ...FlightsIconPlacardInformationLoaded
  }
  fareSeatMapLegendsInformation {
    ...FareSeatMapLegendsInformation
  }
  flightLegsDetails {
    ...FareSeatMapAvailableFlightLegsDetails
  }
  onLoadAccessibilityMessage
  seatMapAlertDialog {
    ...FareSeatMapAlertDialog
  }
  seatMapDialogAnalyticsList {
    ...FlightsAnalytics
  }
  title
}

fragment FareSeatMapAlertDialog on FareSeatMapAlertDialog {
  __typename
  id
  alert {
    __typename
    actions {
      ...FlightsActionInformationLoaded
    }
    animation
    displayedAnalytics {
      ...FlightsAnalytics
    }
    message
    title
  }
}

fragment FareSeatMapAvailableFlightLegsDetails on FareSeatMapAvailableFlightLegsDetails {
  __typename
  flightLegSelectionList {
    ...FareSeatMapAvailableFlightLegSelection
  }
  offerIdentifier
  onViewedAnalytics {
    ...FlightsAnalytics
  }
  pricingConstruct
}

fragment FareSeatMapAvailableFlightLegSelection on FareSeatMapAvailableFlightLegSelection {
  __typename
  errorAnalytics {
    ...FlightsAnalytics
  }
  identifier
  isSelected
  seatMapLegSummary {
    ...FlightsSeatMapLegSummary
  }
  seatSegment {
    ...FlightsSeatSegmentLoaded
  }
  selectedCard {
    ...FlightsIconPlacardInformationLoaded
  }
  unselectedCard {
    ...FlightsIconPlacardInformationLoaded
  }
}

fragment FlightsResponsiveMessage on FlightsResponsiveMessage {
  __typename
  longMessage
  shortMessage
}

fragment FlightsSeatMapTotalDetails on FlightsSeatMapTotalDetails {
  __typename
  label {
    ...FlightsResponsiveMessage
  }
  noSeatSelected
  seatDelimiter
  seatsSelectedMessage {
    ...FlightsSimpleLocalizationTemplate
  }
  selectedSeats {
    ...FlightsSeatMapSeatDetails
  }
  totalPrice {
    ...FlightsSimpleLocalizationTemplate
  }
}

fragment FlightsSeatMapLegSummaryActionType on FlightsSeatMapLegSummaryActionType {
  __typename
  analyticsList {
    ...FlightsAnalytics
  }
  id
}

fragment FlightsSeatMapLegSummary on FlightsSeatMapLegSummary {
  __typename
  buttonAction {
    ...FlightsActionInformationLoaded
  }
  buttonActionTypes {
    ...FlightsSeatMapLegSummaryActionType
  }
  seatTotalDetails {
    ...FlightsSeatMapTotalDetails
  }
  travelerSummary {
    __typename
    title {
      ...FlightsResponsiveMessage
    }
    travelers {
      __typename
      action {
        ... on FlightsActionAndLabel {
          __typename
          label
          selectAction {
            ...FlightsActionInformationLoaded
          }
        }
      }
      id
      seatDetails {
        ...FlightsSeatMapSeatDetails
      }
    }
  }
}

fragment FlightsSeatMapSeatDetails on FlightsSeatMapSeatDetails {
  __typename
  assignedSeat
  id
  price {
    __typename
    amount
    default
    selected {
      ...FlightsSimpleLocalizationTemplate
    }
  }
}

fragment FlightsSimpleLocalizationTemplate on FlightsSimpleLocalizationTemplate {
  __typename
  initialValue
  template
  tokens
}

fragment FlightsSeatSegmentLoaded on SeatSegment {
  fareBasisCode
  identifier
  operatingCarrierCode
}

fragment FareSeatMapLegendsInformation on FareSeatMapLegendsInformation {
  __typename
  accessibilityMessage
  dismissSeatMapLegends {
    ...FlightsAnalytics
  }
  legendDetails {
    ...FlightsSeatMapLegends
  }
  viewLegendButton {
    ...FlightsActionableInformationIconLoaded
  }
}

fragment ClientAnalytics on ClientSideAnalytics {
  __typename
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment clientAction on FlightsClientAction {
  accessibility
  analyticsList {
    ...ClientAnalytics
  }
}

fragment FlightsSeatMapLegends on FlightsSeatMapLegends {
  __typename
  close {
    clientAction {
      ...clientAction
    }
    primary
    style
    accessibility
    disabled
    icon {
      ...IconInformationLoaded
    }
  }
  legendVariants {
    ...FlightsSeatMapLegendVariant
  }
  title
}

fragment FlightsSeatMapLegendVariant on FlightsSeatMapLegendVariant {
  __typename
  legendCard {
    __typename
    text
    accessibilityMessage
    icon {
      ...IconInformationLoaded
    }
  }
  title
}

fragment FlightsLoadedPriceSummary on FlightsLoadedPriceSummary {
  __typename
  bookWithAirlinesDialog {
    ...FlightsDialogPresentation
  }
  breakdown {
    ...FlightsPriceSummaryGroupLoaded
  }
  buttonAction {
    ...FlightsActionInformationLoaded
  }
  dismiss {
    ...FlightsActionableInformationIconLoaded
  }
  policies {
    ...FlightsInformationTextSectionLoaded
  }
  title
  tripTotalLabel
  totals {
    ...FlightsPriceSummaryGroupLoaded
  }
  tripTotalDetails {
    ...FlightsLoadedPriceSummaryTripTotalItem
  }
  viewPriceSummary {
    ...FlightsActionInformationLoaded
  }
  creditShoppingRedirectMessaging
  creditShoppingRedirectAction {
    ...FlightsActionInformationLoaded
  }
  urgencyMessage {
    ...EGDSBadgeFragment
  }
  displayAnalytics {
    ...ClientAnalytics
  }
}

fragment EGDSBadgeFragment on EGDSBadge {
  __typename
  accessibility
  text
  theme
}

fragment FlightsToggleInformationLoaded on FlightsToggle {
  collapseActionable {
    ...TogglePhaseInformationLoaded
  }
  expandActionable {
    ...TogglePhaseInformationLoaded
  }
  expanded
}

fragment IconInformationLoaded on Icon {
  __typename
  description
  id
  size
  withBackground
  theme
}

fragment TogglePhaseInformationLoaded on TogglePhase {
  accessibilityMessage
  action
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconInformationLoaded
  }
}

fragment FlightsIconPlacardInformationLoaded on FlightsIconPlacard {
  heading
  message
  displayType
  icon {
    ...IconInformationLoaded
  }
  actions {
    ...FlightsActionInformationLoaded
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsActionInformationLoaded on FlightsAction {
  __typename
  accessibilityMessage
  accessibilityCheckoutMessage
  analytics {
    ...FlightsAnalytics
  }
  analyticsList {
    ...FlightsAnalytics
  }
  displayAction
  displayType
  enable
  relativePackageableURI {
    relativePath
    value
  }
  relativeURI {
    relativePath
    value
  }
  type
  displayAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment FlightsPriceSummaryGroupLoaded on FlightsPriceSummaryGroup {
  accessibilityMessage
  entries {
    ...FlightsPriceSummaryLoadedItem
  }
  title {
    ...FlightsPriceSummaryLoadedItem
  }
}

fragment FlightsPriceSummaryItemDetailsLoaded on FlightsPriceSummaryItemDetails {
  action {
    ...FlightsActionableInformationIconLoaded
  }
  breakdown {
    ...FlightsPriceSummaryItemGroupLoaded
  }
}

fragment FlightsPriceSummaryItemGroupLoaded on FlightsPriceSummaryItemGroup {
  title
  entries {
    ... on FlightsPriceSummaryItem {
      label
      price
    }
  }
  error {
    ...FlightsPriceSummaryItemErrorLoaded
  }
  action {
    ...FlightsActionInformationLoaded
  }
}

fragment FlightsPriceSummaryItemErrorLoaded on FlightsPriceSummaryItemError {
  message
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsPriceSummaryLoadedItem on FlightsPriceSummaryItem {
  label
  price
  roundedPrice
  details {
    ...FlightsPriceSummaryItemDetailsLoaded
  }
  loyaltyPoints
}

fragment FlightsActionableInformationIconLoaded on FlightsActionableIcon {
  __typename
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconInformationLoaded
  }
  type
  displayText
  accessibilityMessage
}

fragment FlightsInformationTextSectionLoaded on FlightsTextSection {
  displayAction {
    ...FlightsToggleInformationLoaded
  }
  heading
  messages {
    ...FlightsInformationLoadedPhrase
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
  displayAnalyticsList {
    ...FlightsAnalytics
  }
}

fragment FlightsInformationLoadedPhrase on FlightsPhrase {
  __typename
  completeText
  delimeter
  items {
    __typename
    text
    styles
    ... on FlightsPhraseLinkNode {
      accessibility
      analytics {
        ...FlightsAnalytics
      }
      displayAnalytics {
        ...FlightsAnalytics
      }
      scrollAnalytics {
        ...FlightsAnalytics
      }
      link
      icon
    }
  }
}

fragment FlightsLoadedPriceSummaryTripTotalItem on FlightsPriceSummaryTripTotalItem {
  messages {
    heading
    messages {
      completeText
      size
    }
  }
  ratesCurrencyMessage
  ratesCurrencyText
  tripTotal {
    ...FlightsPriceSummaryLoadedItem
  }
}

fragment FlightsDialogPresentation on FlightsDialogPresentation {
  message
  title
  animation
  actions {
    analyticsList {
      ...FlightsAnalytics
    }
    displayAction
    displayType
    accessibilityMessage
    type
    relativeURI {
      relativePath
      value
    }
  }
  displayedAnalytics {
    ...FlightsAnalytics
  }
}

    `;

    export const flightsShoppingPwaFlightServicingResultsQuery = templateJoin`
        query FlightsShoppingPwaFlightServicingResults(
  $context: ContextInput!
  $flightsServicingCriteria: FlightsServicingCriteriaInput!
) {
  flightsServicing(context: $context, flightsServicingCriteria: $flightsServicingCriteria) {
    clientMetadata {
      pageName
      pageNameAnalytics {
        ...FlightsAnalyticsFragment
      }
      pageAnalytics {
        ...ClientSideAnalyticsFragment
      }
    }
    addCollectRequired
    booking {
      primaryText {
        text
      }
    }
    creditResidualMessaging {
      heading {
        text
      }
    }
    importantTripInfo {
      heading {
        text
      }
    }
    payment {
      paymentPresentation {
        heading
      }
    }
    priceSummary {
      title
    }
    reviewAndBook {
      heading {
        text
      }
    }
    tripSummary {
      heading
    }
    serverErrorMessaging {
      emptyState {
        ...FlightServicingBookingEmptyStateFragment
      }
      placards {
        ...FlightsBannerPlacardFragment
      }
    }
  }
}

fragment FlightsAnalyticsFragment on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment ClientSideAnalyticsFragment on ClientSideAnalytics {
  __typename
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment FlightsBannerPlacardFragment on FlightsBannerPlacard {
  __typename
  displayType
  onViewedAnalytics {
    ...FlightsAnalyticsFragment
  }
  banner {
    heading
    message
    fullWidth
  }
}

fragment FlightServicingBookingEmptyStateFragment on FlightServicingBookingEmptyState {
  __typename
  presentation {
    heading
    body
    icon {
      description
      id
      token
    }
    primaryButton {
      accessibility
      primary
      analytics {
        ...ClientSideAnalyticsFragment
      }
    }
  }
  primaryAction {
    ...FlightsResourceLinkActionFragment
    ...FlightsRefreshActionFragment
  }
}

fragment FlightsResourceLinkActionFragment on FlightsResourceLinkAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalyticsFragment
  }
  resource {
    ...HttpURIFragment
    ...TelURIFragment
  }
}

fragment FlightsRefreshActionFragment on FlightsRefreshAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalyticsFragment
  }
}

fragment HttpURIFragment on HttpURI {
  __typename
  relativePath
  value
}

fragment TelURIFragment on TelURI {
  __typename
  phoneNumber
  value
}

    `;

    export const flightsShoppingPwaFlightServicingConfirmationResultsQuery = templateJoin`
        query FlightsShoppingPwaFlightServicingConfirmationResults(
  $context: ContextInput!
  $flightsServicingConfirmationCriteria: FlightsServicingConfirmationCriteriaInput!
) {
  flightsServicingConfirmation(
    context: $context
    flightsServicingConfirmationCriteria: $flightsServicingConfirmationCriteria
  ) {
    confirmationHeading
    clientMetadata {
      pageName
      pageNameAnalytics {
        ...FlightsAnalyticsConfirmationFragment
      }
      pageAnalytics {
        ...ClientSideAnalyticsConfirmationFragment
      }
    }
    errorMessaging {
      emptyState {
        ...FlightServicingBookingEmptyStateConfirmationFragment
      }
    }
  }
}

fragment FlightsAnalyticsConfirmationFragment on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment ClientSideAnalyticsConfirmationFragment on ClientSideAnalytics {
  __typename
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment FlightServicingBookingEmptyStateConfirmationFragment on FlightServicingBookingEmptyState {
  __typename
  presentation {
    heading
    body
    icon {
      description
      id
      token
    }
    primaryButton {
      accessibility
      primary
    }
  }
  primaryAction {
    ...FlightsBookingActionFragment
  }
}

fragment FlightsBookingActionFragment on FlightsBookingAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalyticsConfirmationFragment
  }
}

    `;

    export const flightsSearchMetadataQuery = templateJoin`
        query FlightsSearchMetadata(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput!
  $journeyCriteria: FlightsJourneyCriteriaInput!
) {
  flightsSearchMetadata(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
  ) {
    pageName
    pageAnalytics {
      ...ClientSideImpressionEventAnalyticsFragment
    }
    messaging {
      primary
      secondary
    }
  }
}

fragment ClientSideImpressionEventAnalyticsFragment on ClientSideImpressionEventAnalytics {
  __typename
  linkName
  referrerId
  event
}

    `;

    export const initiateMultiItemSessionQuery = templateJoin`
        mutation InitiateMultiItemSession($context: ContextInput!, $searchContext: MultiItemSearchContextInput!) {
  multiItemShopping(context: $context) {
    initiate(searchContext: $searchContext) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        shoppingContext {
          multiItem {
            id
            packageType
          }
        }
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}

    `;

    export const flightsShoppingPwaFlightSearchFormLoadedQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchFormLoaded(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchPreferences: FlightsSearchPreferencesInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $shoppingContext: ShoppingContextInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchPreferences: $searchPreferences
    travelerDetails: $travelerDetails
    shoppingContext: $shoppingContext
  ) {
    searchForm(queryState: $queryState) {
      ... on FlightsLoadedSearchForm {
        accessibilityMessage
        addJourneyAction {
          analytics {
            ...FlightsAnalytics
          }
          displayAction
          displayType
          type
        }
        appliedFilterCount
        bookingChangeLink {
          ...FlightsResourceLinkAction
        }
        collapseFormAnalytics {
          ...FlightsAnalytics
        }
        closeActionAccessibility
        departureAndReturnDates {
          longMessage
          shortMessage
        }
        errorSummary {
          header
          linkText
          displayAnalytics {
            ...FlightsAnalytics
          }
          linkAnalytics {
            ...FlightsAnalytics
          }
        }
        expandFilterAction {
          icon {
            id
            description
          }
          label
        }
        expandFormAnalytics {
          ...FlightsAnalytics
        }
        expandSearchFormAction {
          id
          description
        }
        closeFormAction {
          displayAction
          analytics {
            ...FlightsAnalytics
          }
        }
        journeys {
          departureDate {
            ...FlightsDate
          }
          destinationLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
            airportLocationType
          }
          label {
            ...FlightsSimpleLocalizationTemplate
          }
          originLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
            airportLocationType
          }
          returnDate {
            ...FlightsDate
          }
          removeJourneyAction {
            displayAction
            analytics {
              ...FlightsAnalytics
            }
            accessibilityUsageMessage {
              ...FlightsSimpleLocalizationTemplate
            }
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
            analytics {
              ...FlightsAnalytics
            }
            accessibilityMessage
            multiDestAccessibilityMessage {
              ...FlightsSimpleLocalizationTemplate
            }
            accessibilityUsageMessage {
              ...FlightsSimpleLocalizationTemplate
            }
          }
        }
        newJourneyTemplate {
          departureDate {
            analytics {
              ...FlightsAnalytics
            }
            handleClickAnalytics {
              ...FlightsAnalytics
            }
            currentError
            date {
              day
              month
              year
              formatted(format: "d MMM uuuu")
              isoFormat
              shortDateFormat
            }
            dateFormat
            daysBookableInAdvance
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            doneAction
          }
          destinationLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
          }
          originLocation {
            analytics {
              ...FlightsAnalytics
            }
            onTypeAnalytics {
              ...FlightsAnalytics
            }
            currentError
            icon {
              id
              description
            }
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            value
            airportCode
          }
          returnDate {
            analytics {
              ...FlightsAnalytics
            }
            handleClickAnalytics {
              ...FlightsAnalytics
            }
            currentError
            date {
              day
              month
              year
              formatted(format: "d MMM uuuu")
              isoFormat
              shortDateFormat
            }
            dateFormat
            daysBookableInAdvance
            label
            placeholder
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            doneAction
          }
          label {
            ...FlightsSimpleLocalizationTemplate
          }
          removeJourneyAction {
            displayAction
            analytics {
              ...FlightsAnalytics
            }
            accessibilityUsageMessage {
              ...FlightsSimpleLocalizationTemplate
            }
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
            analytics {
              ...FlightsAnalytics
            }
            accessibilityMessage
            multiDestAccessibilityMessage {
              ...FlightsSimpleLocalizationTemplate
            }
            accessibilityUsageMessage {
              ...FlightsSimpleLocalizationTemplate
            }
          }
        }
        originAndDestinationLocations
        searchAction
        searchActionAccessibility
        searchActionAnalytics {
          ...FlightsAnalytics
        }
        searchOptions {
          __typename
          ... on FlightsSearchFormAirlineOption {
            label
            icon {
              id
              description
            }
            fieldIcon {
              id
              description
            }
            applyAnalytics {
              ...FlightsAnalytics
            }
            cancelAnalytics {
              ...FlightsAnalytics
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            doneAction
            items {
              airline
              label
              airlineSelectedAnalytics {
                ...FlightsAnalytics
              }
              selected
            }
            selectedItem {
              airline
              label
            }
            closeIcon {
              accessibility
            }
            doneActionAccessibility
          }
          ... on FlightsSearchFormCabinClassOption {
            label
            icon {
              id
              description
            }
            fieldIcon {
              id
              description
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            items {
              cabinClass
              label
              cabinClassSelectedAnalytics {
                ...FlightsAnalytics
              }
              selected
            }
            selectedItem {
              cabinClass
              label
            }
          }
          ... on FlightsSearchFormMoreFiltersOption {
            label
            icon {
              id
              description
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            doneAction
            items {
              advancedFilterSelectedAnalytics {
                ...FlightsAnalytics
              }
              advancedFilterRemoveAnalytics {
                ...FlightsAnalytics
              }
              advancedFilterType
              label
              selected
            }
          }
          ... on FlightsSearchFormTravelersOption {
            label
            travelerLimitLabel
            icon {
              id
              description
            }
            fieldIcon {
              id
              description
            }
            ageRulesLink {
              analytics {
                ...FlightsAnalytics
              }
              accessibility
              displayAction
              url
            }
            applyAnalytics {
              ...FlightsAnalytics
            }
            cancelAction
            cancelAnalytics {
              ...FlightsAnalytics
            }
            changeAnalytics {
              ...FlightsAnalytics
            }
            adultSelectedAnalytics {
              ...FlightsAnalytics
            }
            childrenSelectedAnalytics {
              ...FlightsAnalytics
            }
            infantSelectedAnalytics {
              ...FlightsAnalytics
            }
            infantLapAnalytics {
              ...FlightsAnalytics
            }
            infantSeatAnalytics {
              ...FlightsAnalytics
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            doneAction
            currentErrors
            possibleErrors {
              analytics {
                ...FlightsAnalytics
              }
              message
              type
            }
            valueTemplate {
              oneTemplate
              manyTemplate
              tokens
              fewTemplate
              otherTemplate
              twoTemplate
              zeroTemplate
            }
            items {
              __typename
              caption
              currentError
              increaseCountAccessibility
              decreaseCountAccessibility
              decreaseCountAnalytics {
                ...FlightsAnalytics
              }
              increaseCountAnalytics {
                ...FlightsAnalytics
              }
              label
              max
              minCount
              travelerAgeSelectorTemplate {
                analytics {
                  ...FlightsAnalytics
                }
                items {
                  label
                  selected
                  value
                }
                label {
                  ...FlightsSimpleLocalizationTemplate
                }
                placeholder
              }
              travelerAges {
                analytics {
                  ...FlightsAnalytics
                }
                items {
                  label
                  selected
                  value
                }
                label {
                  ...FlightsSimpleLocalizationTemplate
                }
                placeholder
              }
              travelerCount
              type
              ... on FlightsSearchFormTravelerInfantOptionItem {
                infantsOption {
                  items {
                    label
                    selected
                    type
                  }
                  label
                }
              }
            }
            doneActionAccessibility
            cancelActionAccessibility
          }
          ... on FlightsSearchFormTripTypeOption {
            label
            icon {
              id
              description
            }
            openAnalytics {
              ...FlightsAnalytics
            }
            items {
              label
              selected
              tripType
              tripTypeSelectedAnalytics {
                ...FlightsAnalytics
              }
            }
          }
        }
        airportDropdownEnabled
        availableRoutes {
          destinationsString
          originString
          originCountries {
            countryName
            origins {
              airportName
              airportCode
              destinationCountries {
                countryName
                destinations {
                  airportName
                  airportCode
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment ClientSideAnalytics on ClientSideAnalytics {
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment FlightsSimpleLocalizationTemplate on FlightsSimpleLocalizationTemplate {
  __typename
  initialValue
  template
  tokens
}

fragment FlightsDate on FlightsSearchFormDateField {
  analytics {
    ...FlightsAnalytics
  }
  handleClickAnalytics {
    ...FlightsAnalytics
  }
  currentError
  date {
    day
    month
    year
    formatted(format: "d MMM uuuu")
    isoFormat
  }
  dateFormat
  daysBookableInAdvance
  label
  placeholder
  possibleErrors {
    analytics {
      ...FlightsAnalytics
    }
    message
    type
  }
  doneAction
}

fragment FlightsResourceLinkAction on FlightsResourceLinkAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalytics
  }
  resource {
    ...HttpURI
  }
}

fragment HttpURI on HttpURI {
  __typename
  relativePath
  value
}

    `;

    export const flightsShoppingPwaFlightSearchFormLoadingQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchFormLoading(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $shoppingContext: ShoppingContextInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
    shoppingContext: $shoppingContext
  ) {
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalytics
        }
      }
    }
    searchForm {
      __typename
      ... on FlightsLoadingSearchForm {
        addJourneyAction {
          displayAction
          displayType
        }
        departureAndReturnDates {
          longMessage
          shortMessage
        }
        journeys {
          departureDate {
            date {
              isoFormat
            }
            label
            placeholder
          }
          label {
            initialValue
            template
            tokens
          }
          destinationLocation {
            icon {
              id
            }
            label
            placeholder
            value
            airportCode
            airportLocationType
          }
          originLocation {
            icon {
              id
            }
            label
            placeholder
            value
            airportCode
            airportLocationType
          }
          returnDate {
            date {
              isoFormat
            }
            label
            placeholder
          }
          removeJourneyAction {
            displayAction
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
          }
        }
        originAndDestinationLocations
        searchAction
        searchOptions {
          ... on FlightsSearchFormAirlineOption {
            __typename
            label
            icon {
              id
            }
            selectedItem {
              airline
              label
            }
          }
          ... on FlightsSearchFormCabinClassOption {
            __typename
            label
            icon {
              id
            }
            selectedItem {
              cabinClass
              label
            }
          }
          ... on FlightsSearchFormMoreFiltersOption {
            __typename
            label
            icon {
              id
            }
          }
          ... on FlightsSearchFormTravelersOption {
            __typename
            label
            icon {
              id
            }
            valueTemplate {
              oneTemplate
              manyTemplate
              tokens
              fewTemplate
              otherTemplate
              twoTemplate
              zeroTemplate
            }
            items {
              __typename
              label
              travelerCount
              type
            }
          }
          ... on FlightsSearchFormTripTypeOption {
            __typename
            icon {
              id
            }
            items {
              label
              selected
              tripType
            }
          }
        }
        airportDropdownEnabled
        availableRoutes {
          destinationsString
          originString
          originCountries {
            countryName
            origins {
              airportName
              airportCode
              destinationCountries {
                countryName
                destinations {
                  airportName
                  airportCode
                }
              }
            }
          }
        }
      }
    }
    gaiaId
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

    `;

    export const flightsShoppingPwaFlightSearchResultsFlightsSearchQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchResultsFlightsSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $rewardsOption: RewardsOption
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $searchPagination: PaginationInput
  $shoppingContext: ShoppingContextInput
  $faresSeparationType: FlightsFaresSeparationType
  $flightsSearchComponentCriteria: FlightsSearchComponentCriteriaInput
  $fareCalendarPrice: String
  $flightsDisplayComponentValues: FlightsDisplayComponentValuesInput
  $virtualAgentContext: VirtualAgentContextInput
  $flightsListingsViewType: FlightsListingsViewType
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    rewardsOption: $rewardsOption
    travelerDetails: $travelerDetails
    searchPagination: $searchPagination
    shoppingContext: $shoppingContext
    faresSeparationType: $faresSeparationType
    flightsSearchComponentCriteria: $flightsSearchComponentCriteria
    fareCalendarPrice: $fareCalendarPrice
    flightsDisplayComponentValues: $flightsDisplayComponentValues
    virtualAgentContext: $virtualAgentContext
    flightsListingsViewType: $flightsListingsViewType
  ) {
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalytics
        }
        responseTags
        responseMetrics {
          name
          value
        }
      }
    }
    failedRequestMessaging {
      icon {
        description
        id
      }
      message
      action {
        ...FlightAction
      }
      errorRecoveryButtons {
        ...FlightAction
      }
      title
    }
    noListingMessaging {
      ... on FlightsNoFlightsFoundMessaging {
        __typename
        icon {
          id
          description
        }
        message
        title
      }
      ... on FlightsNoFlightsFoundWithFilterMessaging {
        __typename
        icon {
          id
          description
        }
        message
        clearFiltersAction {
          ...FlightAction
        }
        title
      }
      ... on FlightsActionableErrorMessaging {
        __typename
        icon {
          description
          id
        }
        message
        action {
          ...FlightAction
        }
        errorRecoveryButtons {
          ...FlightAction
        }
        title
      }
      ... on FlightsSmartNoFlightsFoundMessaging {
        __typename
        alternateAirportOptions {
          ...AlternateAirportOptions
        }
        alternateDateOptions {
          ...AlternateDateOptions
        }
        editSearchButton {
          ...FlightAction
        }
        flightsDisplayComponentCountingValue {
          ...FlightsDisplayComponentCountingValue
        }
        icon {
          ...IconSearch
        }
        message
        title
      }
    }
    sortAndFilterResult {
      ... on FlightsLoadedSortAndFilterResult {
        title
        filterAnalyticsList {
          ...FlightsAnalytics
        }
        appliedFiltersSummary {
          appliedFilters {
            analytics {
              ...FlightsAnalytics
            }
            dismissIcon {
              description
              id
            }
            label
            identifier
            nextSearchSortFilterCriteria {
              filterCriteria {
                arrivalAirportCodeFilterValue {
                  airportCode
                }
                arrivalTimeFilterValue {
                  timeOfDay
                }
                departureAirportCodeFilterValue {
                  airportCode
                }
                departureTimeFilterValue {
                  timeOfDay
                }
                durationFilterValue {
                  maxDuration
                }
                numOfStopFilterValue {
                  stopInfo {
                    numberOfStops
                    stopFilterOperation
                  }
                }
                preferredAirlineFilterValue {
                  carrierCode
                }
                flexibleChangePolicyBasedFilterValue {
                  policyName
                }
                seatChoiceBasedFilterValue {
                  seatChoice
                }
                carryOnBagBasedFilterValue {
                  carryOnBag
                }
                checkedBagBasedFilterValue {
                  numOfCheckedBags
                }
                noCancelFeeBasedFilterValue {
                  noCancelFee
                }
                creditEligibleFilterValue {
                  creditEligible
                }
              }
            }
            accessibilityMessage
            dismissIconAccessibility
          }
        }
        applyAction {
          accessibility {
            onCompletion
            usage
          }
          analytics {
            ...FlightsAnalytics
          }
          details
          label
        }
        clearSelectionLabel {
          label
          analytics {
            ...FlightsAnalytics
          }
          accessibility {
            onCompletion
            usage
          }
        }
        clearAllSelectionLabel {
          label
          analytics {
            ...FlightsAnalytics
          }
          accessibility {
            onCompletion
            usage
          }
        }
        dismiss {
          description
          id
        }
        dismissAnalytics {
          ...FlightsAnalytics
        }
        revealAction {
          accessibility {
            onCompletion
            usage
          }
          appliedFilterCount
          iconAndLabel {
            icon {
              description
              id
            }
            label
          }
          enabled
        }
        revealActionAnalytics {
          ...FlightsAnalytics
        }
        sortPresentation {
          __typename
          label
          options {
            accessibility {
              onCompletion
              usage
            }
            analytics {
              ...FlightsAnalytics
            }
            label
            sortType {
              sortOrder
              sortType
            }
          }
          selectedOption {
            label
            sortType {
              sortOrder
              sortType
            }
          }
          selectionActive
        }
        filterPresentation {
          __typename
          accessibility {
            onCompletion
            usage
          }
          eventAnalytics {
            ...FlightsFiltersEventAnalytics
          }
          options {
            __typename
            ... on FlightsListDisplayFilterOption {
              items {
                ...FlightsListDisplayFilterItem
              }
              itemsDefaultDisplayCount
              label
              priceFromLabel
              showMoreToggle {
                ...FlightsToggleSearch
              }
              supportsMultipleSelection
              type
            }
            ... on FlightsCardsDisplayFilterOption {
              items {
                ...FlightsCardsDisplayFilterItem
              }
              label
              type
              supportsMultipleSelection
            }
          }
          title
          emptyFiltersMessage
        }
      }
    }
    listingResult {
      ... on FlightsLoadedListingResult {
        pinnedListingUnavailableMessage
        accessibilityMessage
        appliedFilterAccessibility
        showMoreListingLoadedAccessibilityMessage
        appliedSortingAccessibility
        listings {
          __typename
          ...FlightsSponsoredContentAdListing
          ...FlightsSuggestedFilterMessageListing
          ...FlightsStandardOffer
          ...FlightsBargainFareOffer
          ...FlightsFeedback
          ...FlightsCrossSellMessage
          ...FlightsCrossSellOffer
          ...FlightsCouponCredit
          ...FlightsSustainabilityMessage
          ...FlightsCreditsAvailableListing
          ...FlightsEGDSElementWrapper
          ...FlightsListingMessagingCard
        }
        flightsListingsAnalytics {
          onViewedAnalytics {
            ...FlightsAnalytics
          }
          onViewedAnalyticsList {
            ...FlightsAnalytics
          }
          pinnedListingDisplayedAnalytics {
            ...FlightsAnalytics
          }
          moreListingsDisplayedAnalytics {
            ...FlightsAnalytics
          }
          moreListingsErrorAnalytics {
            ...FlightsAnalytics
          }
          moreListingsLoadTimeAnalytics {
            ...FlightsAnalytics
          }
          fareCalendarAnalytics {
            ...FlightsAnalytics
          }
          fareUpsellPercentageAnalytics {
            ...FlightsAnalytics
          }
          bestBetsDisplayedAnalytics {
            ...FlightsAnalytics
          }
          bestSortDisplayedAnalytics {
            ...FlightsAnalytics
          }
          urgencyMessageAnalytics {
            ...FlightsAnalytics
          }
          nonstopSectionDisplayedAnalytics {
            ...FlightsAnalytics
          }
        }
        listingsAction {
          ...FlightAction
        }
        moreListingsAvailable
      }
    }
    flightsOpinionLab {
      ... on FlightsActionAndLabel {
        label
        selectAction {
          ...FlightAction
        }
      }
    }
    rewardsPricingInfo {
      ...FlightsRewardsPricingInfo
    }
    pageTitle {
      ...PageTitle
    }
    dialogs {
      __typename
      ... on FlightsDialogStandard {
        actions {
          ...FlightAction
        }
        animation
        displayedAnalytics {
          ...FlightsAnalytics
        }
        title
        header
        message
      }
      ... on FlightsDialogStaleSession {
        actions {
          ...FlightAction
        }
        animation
        displayedAnalytics {
          ...FlightsAnalytics
        }
        header
        message
        timeoutInSeconds
      }
      ... on FlightsForcedChoiceCrossSellDialog {
        actions {
          ...FlightAction
        }
        animation
        annotation {
          completeText
          items {
            styles
            text
            __typename
            ... on FlightsPhraseLinkNode {
              analytics {
                ...FlightsAnalytics
              }
              link
            }
          }
        }
        header
        messageBody {
          __typename
          ... on EGDSPlainText {
            __typename
            text
          }
          ... on EGDSGraphicText {
            ...EGDSGraphicTextFragment
          }
        }
        message
        displayCounter
        hotelDatesTitle
        displayedAnalytics {
          ...FlightsAnalytics
        }
        displayBlockedAnalytics {
          ...FlightsAnalytics
        }
        checkInDate {
          ...HotelsDate
        }
        checkOutDate {
          ...HotelsDate
        }
      }
    }
    banners {
      ...FlightsIconPlacard
    }
    allBanners {
      ...FlightsIconPlacard
    }
    cheapestListingInfo {
      price
      analytics {
        ...FlightsAnalytics
      }
      nffAnalytics {
        ...FlightsAnalytics
      }
      deviationAnalytics {
        ...FlightsAnalytics
      }
    }
    gaiaId
    stepIndicator {
      ...FlightsStepIndicator
    }
    flightsReviewLoadingElements {
      freeCancellation {
        ... on FlightsImagePlacard {
          __typename
          image {
            url
            description
          }
          heading
          message
        }
      }
      flightsJourneyReviewCommon {
        changeFlight {
          ...FlightAction
        }
        fareSummarySkeletonCount
        flightSummarySkeletonCount
      }
      clientMetaData {
        ...ClientMetaData
      }
      pageTitle {
        ...PageTitle
      }
      priceSummary {
        __typename
        ... on FlightsLoadingPriceSummary {
          title
          skeletonCount
          tripTotalLabel
          buttonAction {
            ...FlightAction
          }
        }
      }
    }
    shoppingContext {
      multiItem {
        id
        packageType
      }
    }
    listingsHeaderPlacards {
      ...FlightsMessagingCardPlacardFragment
    }
  }
}

fragment FlightsCardsDisplayFilterItem on FlightsCardsDisplayFilterItem {
  accessibility {
    onCompletion
    usage
  }
  card {
    id
    description
  }
  deselectAnalytics {
    ...FlightsAnalytics
  }
  flightsSearchFilterValues {
    arrivalAirportCodeFilterValue {
      airportCode
    }
    arrivalTimeFilterValue {
      timeOfDay
    }
    departureAirportCodeFilterValue {
      airportCode
    }
    departureTimeFilterValue {
      timeOfDay
    }
    durationFilterValue {
      maxDuration
    }
    numOfStopFilterValue {
      stopInfo {
        stopFilterOperation
        numberOfStops
      }
    }
    preferredAirlineFilterValue {
      carrierCode
    }
    flexibleChangePolicyBasedFilterValue {
      policyName
    }
    seatChoiceBasedFilterValue {
      seatChoice
    }
    carryOnBagBasedFilterValue {
      carryOnBag
    }
    checkedBagBasedFilterValue {
      numOfCheckedBags
    }
    noCancelFeeBasedFilterValue {
      noCancelFee
    }
    creditEligibleFilterValue {
      creditEligible
    }
  }
  label
  identifier
  subLabel
  selectAnalytics {
    ...FlightsAnalytics
  }
  selected
  value {
    __typename
    ... on FlightsAirportCodeFilterValue {
      airportCode
    }
    ... on FlightsDurationBasedFilterValue {
      maxDuration
    }
    ... on FlightsPreferredAirlineFilterValue {
      carrierCode
    }
    ... on FlightsFlexibleChangePolicyBasedFilterValue {
      policyName
    }
    ... on FlightsSeatChoiceBasedFilterValue {
      seatChoice
    }
    ... on FlightsCarryOnBagBasedFilterValue {
      carryOnBag
    }
    ... on FlightsCheckedBagBasedFilterValue {
      numOfCheckedBags
    }
    ... on FlightsNoCancelFeeBasedFilterValue {
      noCancelFee
    }
    ... on FlightsStopBasedFilterValue {
      stopInfo {
        stopFilterOperation
        numberOfStops
      }
    }
    ... on FlightsTimeBasedFilterValue {
      timeOfDay
    }
    ... on FlightsCreditEligibleFilterValue {
      creditEligible
    }
  }
}

fragment FlightsListDisplayFilterItem on FlightsListDisplayFilterItem {
  selectPositionAnalytics {
    ...FlightsAnalytics
  }
  analytics {
    ...FlightsFilterItemAnalytics
  }
  accessibility {
    onCompletion
    usage
  }
  deselectAnalytics {
    ...FlightsAnalytics
  }
  flightsSearchFilterValues {
    arrivalAirportCodeFilterValue {
      airportCode
    }
    arrivalTimeFilterValue {
      timeOfDay
    }
    departureAirportCodeFilterValue {
      airportCode
    }
    departureTimeFilterValue {
      timeOfDay
    }
    durationFilterValue {
      maxDuration
    }
    numOfStopFilterValue {
      stopInfo {
        stopFilterOperation
        numberOfStops
      }
    }
    preferredAirlineFilterValue {
      carrierCode
    }
    flexibleChangePolicyBasedFilterValue {
      policyName
    }
    seatChoiceBasedFilterValue {
      seatChoice
    }
    carryOnBagBasedFilterValue {
      carryOnBag
    }
    checkedBagBasedFilterValue {
      numOfCheckedBags
    }
    noCancelFeeBasedFilterValue {
      noCancelFee
    }
    creditEligibleFilterValue {
      creditEligible
    }
  }
  label
  identifier
  selectAnalytics {
    ...FlightsAnalytics
  }
  selected
  formattedMultiItemStartingPrice
  startingPrice {
    formatted
  }
  value {
    __typename
    ... on FlightsAirportCodeFilterValue {
      airportCode
    }
    ... on FlightsDurationBasedFilterValue {
      maxDuration
    }
    ... on FlightsPreferredAirlineFilterValue {
      carrierCode
    }
    ... on FlightsFlexibleChangePolicyBasedFilterValue {
      policyName
    }
    ... on FlightsSeatChoiceBasedFilterValue {
      seatChoice
    }
    ... on FlightsCarryOnBagBasedFilterValue {
      carryOnBag
    }
    ... on FlightsCheckedBagBasedFilterValue {
      numOfCheckedBags
    }
    ... on FlightsNoCancelFeeBasedFilterValue {
      noCancelFee
    }
    ... on FlightsStopBasedFilterValue {
      stopInfo {
        stopFilterOperation
        numberOfStops
      }
    }
    ... on FlightsTimeBasedFilterValue {
      timeOfDay
    }
    ... on FlightsCreditEligibleFilterValue {
      creditEligible
    }
  }
}

fragment FlightsBargainFareOffer on FlightsBargainFareOffer {
  bargainOfferAccessibilityMessage: accessibilityMessage
  accessibilityHeading
  bargainPricingInformation {
    priceLockup {
      ...PriceLockupFragment
    }
    cancellationMessage
    price {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
    mainPrice {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
    pricePerTraveler {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
    taxesLabel
    totalLabel
    totalPriceForAllTravelers {
      completeText
      items {
        styles
        text
        __typename
        ... on FlightsPhraseLinkNode {
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
    tripType
    subText
  }
  description {
    completeText
    items {
      styles
      text
      __typename
      ... on FlightsPhraseLinkNode {
        analytics {
          ...FlightsAnalytics
        }
        link
      }
    }
  }
  header {
    completeText
    items {
      text
      styles
      __typename
      ... on FlightsPhraseLinkNode {
        link
        analytics {
          ...FlightsAnalytics
        }
      }
    }
  }
  image {
    url
  }
  journeys {
    __typename
    flightsJourneyAvailableFaresInformation {
      ...FlightsJourneyAvailableFares
    }
    flightsDetailsAndFaresPresentation {
      ...FlightsDetailsAndFaresPresentationFragment
    }
  }
  journeyContinuationId
  onClickAnalyticsList {
    ...FlightsAnalytics
  }
  stepIndicatorJcid
}

fragment FlightsSuggestedFilterMessageListing on FlightsSuggestedFilterMessageListing {
  __typename
  suggestedFilterDetails {
    __typename
    ... on FlightsImagePlacard {
      image {
        url
      }
      heading
      message
      actions {
        ... on FlightsAction {
          displayAction
          displayType
          type
          analytics {
            ...FlightsAnalytics
          }
        }
      }
    }
  }
  suggestedFilter {
    ... on FlightsSuggestedFilterItem {
      selected
      accessibility {
        usage
        onCompletion
      }
      identifier
      label
      value {
        ... on FlightsFlexibleChangePolicyBasedFilterValue {
          policyName
        }
      }
      type
    }
  }
}

fragment FlightsSustainabilityMessage on FlightsSustainabilityMessage {
  details {
    ...FlightsSustainabilityDialogDetails
  }
  information {
    ...FlightsIconPlacard
  }
}

fragment FlightsSustainabilityDialogDetails on FlightsSustainabilityDialogDetails {
  heading
  dismiss {
    ...FlightAction
  }
  closingText {
    ...FlightsTextSection
  }
  iconRow {
    ... on FlightsIconAndHeading {
      heading
      icons {
        ...FlightsIconAndLabel
      }
    }
  }
  introduction {
    ...FlightsPhrase
  }
}

fragment FlightsTextSection on FlightsTextSection {
  heading
  displayAnalytics {
    ...FlightsAnalytics
  }
  messages {
    ...FlightsPhrase
  }
}

fragment FlightsFeedback on FlightsFeedback {
  __typename
  feedbackLinkAction {
    ...FlightAction
  }
  iconAndLabel {
    icon {
      description
      id
    }
    label
    accessibility
  }
}

fragment FlightsCouponCredit on FlightsCouponCredit {
  couponCreditAction {
    ...FlightAction
  }
  imageListingLabel {
    ...FlightsImageListingLabel
  }
}

fragment FlightsImageListingLabel on FlightsImageListingLabel {
  image {
    url
  }
  label
  subLabel
}

fragment MultiItemSearchContext on MultiItemSearchContext {
  flights {
    primary {
      journeyCriterias {
        departureDate {
          day
          month
          year
        }
        origin
        destination
      }
      searchPreferences {
        cabinClass
        advancedFilters
      }
      tripType
      travelers {
        age
        type
      }
    }
  }
}

fragment FlightsEGDSElementWrapper on EGDSElementWrapper {
  element {
    ...EgdsTextFragment
  }
}

fragment FlightsCrossSellMessage on FlightsCrossSellMessage {
  __typename
  multiItemFlightCrossSellPrimer {
    flightCrossSellProductType
    multiItemSearchContext {
      ...MultiItemSearchContext
    }
  }
}

fragment FlightsSponsoredContentAdListing on FlightsSponsoredContentAdListing {
  __typename
  sponsoredContentPlacement {
    productType
    sponsoredContentContext {
      pageName 
      sponsoredContentId
      targeting {
        adults
        dateEnd {
          ...DateFragment
        }
        dateStart {
          ...DateFragment
        }
        destination
        kids
        locationResolver
        origin
      }
      variant
    }
  }
}

fragment FlightsStandardOffer on FlightsStandardOffer {
  __typename
  accessibilityHeading
  accessibilityMessage
  pinnedOfferMessage
  badges {
    accessibilityMessage
    icon {
      description
      id
    }
    text
    type
  }
  journeys {
    __typename
    airlines {
      image {
        url
        description
      }
      text
    }
    cabinClass
    departureAndArrivalTime {
      completeText
      items {
        styles
        text
      }
    }
    departureAndArrivalLocations
    layoverInformation
    differentDayArrival
    differentDayArrivalAccessibilityMessage
    displayAction {
      id
      description
    }
    durationAndStops
    flightOperatedBy
    label
    urgencyMessage
    urgencyAccessibilityMessage
    flightsJourneyAvailableFaresInformation {
      ...FlightsJourneyAvailableFares
    }
    flightsDetailsAndFaresPresentation {
      ...FlightsDetailsAndFaresPresentationFragment
    }
    hygieneAmenitiesMessage
    adjustedStayDatesMessage {
      ...FlightsIconPhrases
    }
    positiveHighlightsMessage
    restrictiveAmenityIcons {
      ...IconSearch
    }
    highlightRelevantFaresAnalytics {
      ...FlightsAnalytics
    }
  }
  pricingInformation {
    loyaltyEarnMessage {
      ...FlightsMarkAndLabel
    }
    partnerLoyaltyEarnMessage {
      ...FlightsMarkAndLabel
    }
    loyaltyPointsOption {
      ...FlightsLoyaltyPointsOption
    }
    price {
      completeText
      items {
        text
        styles
      }
    }
    mainPrice {
      completeText
      items {
        text
        styles
      }
    }
    subPrice {
      completeText
      items {
        text
        styles
      }
    }
    pricePerTraveler {
      completeText
      items {
        text
        styles
      }
    }
    taxesLabel
    totalLabel
    totalPriceForAllTravelers {
      completeText
      items {
        text
        styles
      }
    }
    subText
    tripType
    priceLockup {
      ...PriceLockupFragment
    }
    subTexts {
      text
      ... on EGDSStylizedText {
        theme
      }
    }
  }
  restrictiveFareRules {
    dismissLabel
    displayAction {
      icon {
        id
        description
      }
      label {
        completeText
        items {
          styles
          text
        }
      }
    }
    rules
    title
  }
  specialFareType
  sponsoredAirline {
    airlineName
    airlineImage {
      url
    }
    airlineCode
    adUnitID
    advertiserID
    creativeID
    clickTrackingURL
    delayedImpressionURL
    orderID
    sponsoredHeader
    sponsoredText
  }
  tag {
    image {
      description
      url
    }
    message
  }
  flightsOfferAnalytics {
    onViewedAnalyticsList {
      ...FlightsAnalytics
    }
  }
  journeyContinuationId
  onClickAnalyticsList {
    ...FlightsAnalytics
  }
  sponsoredUpsell {
    ...FlightsOfferSponsoredUpsell
  }
  stepIndicatorJcid
}

fragment FlightsCreditsAvailableListing on FlightsCreditsAvailableListing {
  immediateDialogAction {
    accessibility
    analytics {
      ...ClientSideAnalytics
    }
    dialog {
      closeAnalytics {
        ...ClientSideAnalytics
      }
    }
    dialogContents {
      egdsElementId
    }
  }
  messagingCardPlacard {
    __typename
    button {
      ...FlightsActionButton
    }
    displayType
    messagingCard {
      ...UIMessagingCard
    }
    onViewedAnalytics {
      ...FlightsAnalytics
    }
  }
  toastNotification {
    __typename
    egdsElementId
    text
  }
}

fragment FlightsActionButton on FlightsActionButton {
  __typename
  accessibility
  clientAction {
    __typename
    accessibility
    analyticsList {
      ...ClientSideAnalytics
    }
    ...FlightsBoundNavigation
    ...FlightsCreditSelectorOpenAction
    ...FlightsNavigateToDetails
    ...FlightsResourceLinkAction
    ...FlightsSelectionAction
    ...MultiItemSelectPackage
    ...MultiItemSelectProducts
  }
  disabled
  egdsElementId
  icon {
    ...IconSearch
  }
  primary
  style
  buttonStyle: style
  action {
    __typename
    accessibility
    analytics {
      ...ClientSideAnalytics
    }
  }
}

fragment FlightsResourceLinkAction on FlightsResourceLinkAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalytics
  }
  resource {
    ...HttpURI
  }
}

fragment HttpURI on HttpURI {
  __typename
  relativePath
  value
}

fragment FlightsCreditSelectorOpenAction on FlightsCreditSelectorOpenAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalytics
  }
}

fragment FlightsSelectionAction on FlightsSelectionAction {
  value
}

fragment FlightsBoundNavigation on FlightsBoundNavigation {
  jcid
  mipt
  pageId
  stepIndicatorJcid
}

fragment FlightsNavigateToDetails on FlightsNavigateToDetails {
  dialogId
  nextPage {
    ...HttpURI
  }
  packagesUrl {
    ...HttpURI
  }
}

fragment MultiItemSelectProducts on MultiItemSelectProducts {
  flightsOfferNaturalKeys {
    ...FlightsOfferNaturalKeysFragment
  }
  multiItemPriceToken
  multiItemSessionId
}

fragment MultiItemSelectPackage on MultiItemSelectPackage {
  packageOfferId
}

fragment UIMessagingCard on UIMessagingCard {
  __typename
  egdsElementId
  graphic {
    ...UIGraphicFragment
  }
  primary
  secondaries
}

fragment ClientSideAnalytics on ClientSideAnalytics {
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment FlightsLoyaltyPointsOption on FlightsLoyaltyPointsOption {
  overageAmount
  strikeThroughFormattedPoints
  leadingCaption
  formattedPoints
  isPointsFirst
  isStrikeThroughFirst
  accessibility
}

fragment FlightsMarkAndLabel on FlightsMarkAndLabel {
  accessibility
  label
  subLabel
  mark {
    id
    description
  }
  stylisedText {
    ...EGDSSpannableTextFragment
  }
}

fragment FlightsToggleSearch on FlightsToggle {
  __typename
  collapseActionable {
    ...TogglePhaseSearch
  }
  expandActionable {
    ...TogglePhaseSearch
  }
  expanded
}

fragment IconSearch on Icon {
  __typename
  description
  id
  size
  withBackground
  theme
  title
}

fragment TogglePhaseSearch on TogglePhase {
  __typename
  accessibilityMessage
  action
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconSearch
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment FlightsIconPlacard on FlightsIconPlacard {
  __typename
  heading
  message
  icon {
    description
    id
    size
    withBackground
  }
  actions {
    ...FlightAction
  }
  displayType
}

fragment FlightAction on FlightsAction {
  __typename
  accessibilityMessage
  analytics {
    ...FlightsAnalytics
  }
  analyticsList {
    ...FlightsAnalytics
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
  displayAction
  displayType
  accessibilityActionMessage {
    usage
    onCompletion
  }
  icon {
    ...IconSearch
  }
  journeySearchCriteria {
    previousFlightSelections {
      journeyIndex
      offerIdentifier
    }
    journeyCriteria {
      destination
      departureDate {
        day
        month
        year
      }
      origin
    }
    searchPreferences {
      cabinClass
    }
  }
  relativeURI {
    relativePath
    value
  }
  relativePackageableURI {
    relativePath
    value
  }
  stepIndicator {
    ...FlightsStepIndicator
  }
  searchPagination {
    ...Pagination
  }
  type
}

fragment FlightsStepIndicator on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalytics
  }
  journeyContinuationId
}

fragment CoordinateInformationSearch on CoordinateInformation {
  icon {
    ...IconSearch
  }
  flightDetailsWarningInfo {
    ...FlightsIconAndLabel
  }
  subtitle
  titleAndAccessibilityMessage {
    accessibilityMessage
    text
  }
}

fragment FlightsJourneyAvailableFares on FlightsJourneyAvailableFares {
  __typename
  applySelection {
    ...FlightAction
  }
  fareChoiceInformation {
    __typename
    availableFaresCount
    defaultBaggageInformation {
      bagFeesMoreInfo {
        __typename
        completeText
        delimeter
        items {
          styles
          text
          ... on FlightsPhraseLinkNode {
            accessibility
            icon
            link
          }
        }
      }
      defaultBagSelectionMessage
      details {
        baggageDetail
        topic
      }
      dismissAction
      displayDetailsAction
      label
    }
    fares {
      __typename
      accessibilityMessage
      selectFareActionAltText
      multiItemPriceToken
      multiItemAction {
        __typename
        ... on MultiItemSelectPackageAction {
          packageOfferId
        }
        ... on MultiItemSelectProductsAction {
          multiItemSessionId
          flightsOfferNaturalKeys {
            ...FlightsOfferNaturalKeysFragment
          }
          multiItemPriceToken
        }
      }
      flightsOfferNaturalKeys {
        ...FlightsOfferNaturalKeysFragment
      }
      baggageFeesInformation {
        __typename
        defaultBagSelectionMessage
        details {
          __typename
          baggageDetail
          topic
        }
        displayDetailsAction
        dismissAction
        label
      }
      cabinClass
      cabinClassAndBookingCodes
      selectFareAction {
        ...FlightAction
      }
      collapsedRules {
        ...FlightsJourneyAmenities
      }
      expandedRules {
        ...FlightsJourneyAmenitiesWithLabel
      }
      amenityHierarchyRules {
        ...FlightsJourneyAmenitiesWithLabel
      }
      amenityRules {
        __typename
        amenities {
          ...FlightsIconAndLabel
        }
        itemsDefaultDisplayCount
      }
      chooseFareAction {
        __typename
        accessibilityMessage
        displayAction
        type
      }
      loyaltyPointsOption {
        ...FlightsLoyaltyPointsOption
      }
      partnerLoyaltyEarnAward {
        ...FlightsMarkAndLabel
      }
      identifier
      name
      recommendation {
        ...FlightsBadge
      }
      selected
      showMoreAmenitiesToggle {
        ...FlightsToggleSearch
      }
      totalPrice
      priceAccessibilityMessage
      journeyFareTotalPrice
      upsellOfferToken
      badges {
        accessibility
        text
        theme
      }
      priceLockup {
        accessibilityPrice
        lockupPrice
        strikeThroughPrice
        priceSubtextFirst
      }
    }
    heading {
      ...FlightsResponsiveMessage
    }
    message
    nextFareChoiceAccessibilityMessage
    previousFareChoiceAccessibilityMessage
    tripTypePerTraveler
    percentageDelaysAndCancellationLink {
      __typename
      analytics {
        ...FlightsAnalytics
      }
      displayAction
      url
      accessibility
    }
    sustainabilityInformation {
      ...FlightsIconPhrases
    }
    dialogs {
      ...FaresDialogsFragment
    }
  }
  flightsJourneyHeaders {
    accessibilityMessage
    flightsJourneySubheadingMark {
      description
      id
      size
      token
      url {
        relativePath
        value
      }
    }
    journeyAmenities {
      ...FlightsJourneyAmenities
    }
    flightsJourneySubheading
    heading
  }
  flightsJourneyInformation {
    ...FlightsJourneyInformation
  }
  flightsJourneySummary {
    __typename
    heading {
      __typename
      accessibilityMessage
      text
    }
    differentDayArrival {
      __typename
      accessibilityMessage
      text
      theme
      size
    }
    basicFlightDetails {
      __typename
      accessibilityMessage
      text
      theme
    }
    ... on FlightsBargainJourneySummary {
      arrivalDayInformation
      formattedPrice {
        completeText
        items {
          styles
          text
        }
      }
      tripTypePerTraveler
      totalPrice
    }
  }
  hygieneAmenitiesPresentation {
    __typename
    amenitiesAction {
      __typename
      heading
    }
    airlineAmenityGroups {
      __typename
      headerText
      amenities {
        icon {
          ...IconSearch
        }
        label
        theme
      }
    }
    disclaimerMessage
  }
}

fragment FlightsDetailsAndFaresPresentationFragment on FlightsDetailsAndFaresPresentation {
  __typename
  content {
    ...FlightsDetailsAndFaresContentFragment
  }
  flightsFaresWrapper {
    ...FlightsDialogSheetFragment
  }
  footer {
    ...FlightsDetailsAndFaresFooterFragment
  }
  trigger {
    ...FlightsDialogTriggerFragment
  }
}

fragment FlightsDetailsAndFaresContentFragment on FlightsDetailsAndFaresContent {
  __typename
  dialogId
  dynamicDialogId
  nestedDialogs {
    ...FaresDialogsFragment
  }
  priceMatchPromiseNestedDialogs {
    ...FaresDialogsFragment
  }
  sections {
    __typename
    ...FlightsJourneyHeaderFragment
    ...FlightsJourneyDetailsInformationFragment
    ...FlightsJourneyWithDetailsFragment
    ...FlightsHygieneAmenitiesSectionFragment
    ...TextWrapperFragment
    ...FlightsFaresInformationFragment
    ...FlightsSustainabilityCardFragment
    ...FlightsMessagingCardFragment
  }
}

fragment FlightsFaresInformationFragment on FlightsFaresInformation {
  __typename
  carousel {
    ...EGDSCarouselContainerFragment
  }
  faresCarousel {
    ...EGDSCarouselFragment
  }
  heading
  fares {
    ...FareInformationCardFragment
  }
  subheading
  scrollAnalytics {
    ...ClientSideAnalytics
  }
}

fragment EGDSCarouselFragment on EGDSCarousel {
  nextButton {
    ...EGDSButtonFragment
  }
  previousButton {
    ...EGDSButtonFragment
  }
}

fragment FlightsDialogSheetFragment on FlightsDialogSheet {
  __typename
  dialog {
    ...FaresDialogsFragment
  }
  dialogId
  dynamicDialogId
  sheet {
    ...FlightsSideSheetFragment
  }
}

fragment FlightsDetailsAndFaresFooterFragment on FlightsDetailsAndFaresFooter {
  __typename
  action {
    ...FlightsActionButton
  }
  dialogId
  dynamicDialogId
  priceLockup {
    ...PriceLockupFragment
  }
}

fragment FlightsJourneyHeaderFragment on FlightsJourneyHeaderInformation {
  __typename
  content {
    ...FlightsInformationTextFragment
  }
}

fragment FlightsJourneyDetailsInformationFragment on FlightsJourneyDetailsInformation {
  __typename
  content {
    ...FlightsJourneyDetailsFragment
  }
  expando {
    ...EGDSExpandoFragment
  }
}

fragment FlightsJourneyDetailsFragment on FlightsJourneyDetails {
  __typename
  journeySections {
    ...JourneySectionFragment
  }
  journeyAmenities {
    ...FlightsIconAndLabel
  }
}

fragment FlightsJourneyWithDetailsFragment on FlightsJourneyWithDetails {
  __typename
  details {
    ...EgdsTextFragment
  }
  footnotes {
    ...EgdsTextFragment
  }
  header
  subheader
}

fragment FlightsHygieneAmenitiesSectionFragment on FlightsHygieneAmenitiesSection {
  __typename
  header
  footer
  amenities {
    ...EGDSIconTextFragment
  }
}

fragment TextWrapperFragment on TextWrapper {
  textA11yMessage: accessibilityMessage
  text {
    ...EgdsTextFragment
    ...EGDSSpannableTextFragment
    __typename
  }
  __typename
}

fragment FlightsSustainabilityCardFragment on FlightsSustainabilityCard {
  __typename
  cardContent {
    text {
      ...FlightsPhrase
    }
    icon {
      ...IconSearch
    }
  }
}

fragment FareInformationCardFragment on FareInformationCard {
  __typename
  action {
    ...FareActionFragment
  }
  amenities {
    ...FlightsCategorizedListFragment
  }
  fareDetails {
    ...EgdsTextFragment
  }
  heading {
    ...FareHeadingFragment
  }
  priceMatchPromise {
    ...FarePriceMatchPromisePresentationFragment
  }
  state
  highlighted
  scrollAnalytics {
    ...ClientSideAnalytics
  }
  fareTabs {
    __typename
    ...EGDSBasicTabsFragment
  }
  sponsoredContent {
    ...FlightsSponsoredUpsellDetails
  }
}

fragment EGDSBasicTabsFragment on EGDSBasicTabs {
  egdsElementId
  selectedTabId
  tabs {
    ... on EGDSBasicTab {
      tabId
      label
      accessibility
      clickAnalytics {
        ...ClientSideAnalytics
      }
    }
  }
}

fragment FlightsSideSheetFragment on FlightsSideSheet {
  content {
    ...EgdsElementFragment
  }
  footer {
    ...EgdsElementFragment
  }
  title
  __typename
}

fragment JourneySectionFragment on JourneySection {
  __typename
  journeyConnectionInformation {
    ... on AdditionalInformation {
      ...AdditionalInformationFragment
    }
    ... on FlightsConnectionInformation {
      ...FlightsConnectionInformationFragment
    }
  }
}

fragment EGDSExpandoFragment on EGDSExpando {
  __typename
  ... on EGDSExpandoPeek {
    ...EGDSExpandoPeekFragment
  }
  ... on EGDSExpandoListItem {
    ...EGDSExpandoListItemFragment
  }
  ... on EGDSExpandoLink {
    ...EGDSExpandoLinkFragment
  }
}

fragment EGDSIconTextFragment on EGDSIconText {
  __typename
  icon {
    ...IconSearch
  }
  text
}

fragment EGDSCarouselContainerFragment on EGDSCarouselContainer {
  __typename
  accessibilityHeadingText
  nextButtonText
  previousButtonText
}

fragment FareActionFragment on FareAction {
  __typename
  action {
    ...FlightsActionButton
  }
  states
}

fragment FlightsCategorizedListFragment on FlightsCategorizedList {
  __typename
  sections {
    ...FlightsCategorizedListSectionFragment
  }
}

fragment FlightsCategorizedListSectionFragment on FlightsCategorizedListSection {
  __typename
  flightsCategorizedListSectionA11yMessage: accessibilityMessage
  footnote
  heading
  additionalInfo
  items {
    ...FlightsCategorizedListItemFragment
  }
}

fragment FlightsCategorizedListItemFragment on FlightsCategorizedListItem {
  __typename
  primary {
    ...EGDSSpannableTextFragment
  }
  secondary
  tertiary
}

fragment FareHeadingFragment on FareHeading {
  __typename
  badge {
    ...EGDSBadgeFragment
  }
  farePricing {
    ...FarePricingFragment
  }
}

fragment FarePriceMatchPromisePresentationFragment on FarePriceMatchPromisePresentation {
  __typename
  cards {
    ...FarePriceMatchPromiseSelectableCardFragment
    ...FarePriceMatchPromiseRemovableCardFragment
    ...FarePriceMatchPromiseStaticCardFragment
  }
  priceMatchPromiseState
}

fragment FarePriceMatchPromiseStaticCardFragment on FarePriceMatchPromiseStaticCard {
  __typename
  heading {
    ...EGDSIconTextFragment
  }
  priceMatchPromiseState
  subHeading
}

fragment FarePriceMatchPromiseRemovableCardFragment on FarePriceMatchPromiseRemovableCard {
  __typename
  heading {
    ...EGDSIconTextFragment
  }
  priceMatchPromiseState
  removeAction {
    ...FlightsActionLinkFragment
  }
  subHeading
}

fragment AdditionalInformationFragment on AdditionalInformation {
  __typename
  durationAndStop
  nextFlightOriginAirportInfo {
    ...FlightsIconAndLabel
  }
}

fragment FlightsConnectionInformationFragment on FlightsConnectionInformation {
  __typename
  flightsConnection {
    aircraftModel
    airlineInfo
    cabinClassAndBookingCode
    connectionArrival {
      ...CoordinateInformationSearch
    }
    connectionDeparture {
      ...CoordinateInformationSearch
    }
    duration
    journeyAmenities {
      ...FlightsJourneyAmenities
    }
  }
}

fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {
  __typename
  expandedLabel
  collapsedLabel
  expandAnalytics {
    ...ClientSideAnalytics
  }
  threshold
  minimalHeight
}

fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {
  __typename
  collapseAnalytics {
    ...ClientSideAnalytics
  }
  collapsedLabel
  expandAnalytics {
    ...ClientSideAnalytics
  }
  expandedLabel
  expanded
}

fragment EGDSExpandoLinkFragment on EGDSExpandoLink {
  __typename
  collapseAnalytics {
    ...ClientSideAnalytics
  }
  collapsedLabel
  expandAnalytics {
    ...ClientSideAnalytics
  }
  expanded
  expandedLabel
}

fragment FlightsInformationTextFragment on FlightsInformationText {
  __typename
  content {
    ...FlightsInformationTextItemFragment
  }
}

fragment FlightsInformationTextItemFragment on FlightsInformationTextItem {
  ...MarkWrapperFragment
  ...TextWrapperFragment
  ...IconWrapperFragment
  ...SuperlativeTextFragment
}

fragment EGDSBadgeFragment on EGDSBadge {
  __typename
  accessibility
  text
  theme
}

fragment FarePricingFragment on FarePricing {
  __typename
  priceLockup {
    ...PriceLockupFragment
  }
  states
}

fragment FarePriceMatchPromiseSelectableCardFragment on FarePriceMatchPromiseSelectableCard {
  __typename
  checkbox {
    ...FlightsActionCheckboxFragment
  }
  heading {
    ...EGDSIconTextFragment
  }
  infoTrigger {
    ...FlightsDialogTriggerFragment
  }
  price
  priceMatchPromiseState
  description
}

fragment EGDSSpannableTextFragment on EGDSSpannableText {
  __typename
  text
  contents {
    __typename
    ... on EGDSHeading {
      text
      headingType
    }
    ... on EGDSParagraph {
      text
      style
    }
    ... on EGDSIconText {
      text
      icon {
        id
        size
      }
    }
    ... on EGDSStandardLink {
      text
      action {
        __typename
        accessibility
        target
        resource {
          __typename
          value
        }
        analytics {
          __typename
          linkName
          referrerId
        }
      }
    }
    ... on EGDSPlainText {
      text
    }
    ... on EGDSStylizedText {
      decorative
      text
      theme
      weight
      stylizedSize: size
    }
  }
  inlineContent {
    __typename
    ... on EGDSHeading {
      text
      headingType
    }
    ... on EGDSGraphicText {
      ...EGDSGraphicTextFragment
    }
    ... on EGDSStandardLink {
      text
      action {
        __typename
        accessibility
        target
        resource {
          __typename
          value
        }
        analytics {
          __typename
          linkName
          referrerId
        }
      }
    }
    ... on EGDSPlainText {
      text
    }
    ... on EGDSStylizedText {
      decorative
      text
      theme
      weight
      stylizedSize: size
    }
  }
}

fragment MarkWrapperFragment on MarkWrapper {
  __typename
  mark {
    ...MarkFragments
  }
}

fragment IconWrapperFragment on IconWrapper {
  __typename
  iconA11yMessage: accessibilityMessage
  icons {
    ...IconSearch
  }
}

fragment MarkFragments on Mark {
  __typename
  description
  id
  markSize: size
  url {
    ... on HttpURI {
      __typename
      relativePath
      value
    }
  }
}

fragment SuperlativeTextFragment on SuperlativeText {
  __typename
  superlativeTextA11yMessage: accessibilityMessage
  text {
    ...EgdsTextFragment
  }
}

fragment FlightsJourneyAmenities on FlightsJourneyAmenities {
  __typename
  accessibilityMessage
  amenities {
    ...FlightsIconAndLabel
  }
  analytics {
    ...FlightsAnalytics
  }
}

fragment FlightsJourneyAmenitiesWithLabel on FlightsJourneyAmenitiesWithLabel {
  __typename
  label
  rules {
    ...FlightsJourneyAmenities
  }
}

fragment Pagination on Pagination {
  __typename
  size
  startingIndex
}

fragment FlightsIconAndLabel on FlightsIconAndLabel {
  __typename
  icon {
    ...IconSearch
  }
  label
  subLabel
  accessibility
  value
  theme
  displayAnalytics {
    ...FlightsAnalytics
  }
  subText {
    ... on EGDSStylizedText {
        decorative
        text
        theme
        weight
        size
    }
  }
}

fragment FlightsJourneyInformation on FlightsDetailedJourneyInformation {
  __typename
  details {
    ...FlightsToggleSearch
  }
  flightJourneyDetails {
    __typename
    journeySections {
      journeyConnectionInformation {
        __typename
        ... on AdditionalInformation {
          durationAndStop
          nextFlightOriginAirportInfo {
            ...FlightsIconAndLabel
          }
        }
        ... on FlightsConnectionInformation {
          flightsConnection {
            aircraftModel
            airlineInfo
            cabinClassAndBookingCode
            connectionArrival {
              ...CoordinateInformationSearch
            }
            connectionDeparture {
              ...CoordinateInformationSearch
            }
            duration
            journeyAmenities {
              ...FlightsJourneyAmenities
            }
            operatedBy
          }
        }
      }
    }
    journeyAmenities {
      ...FlightsIconAndLabel
    }
  }
}

fragment FlightsBadge on FlightsBadge {
  __typename
  accessibilityMessage
  icon {
    id
    description
  }
  text
  type
}

fragment HotelsDate on FlightsSearchFormDateField {
  __typename
  analytics {
    ...FlightsAnalytics
  }
  currentError
  date {
    day
    month
    year
    formatted(format: "d MMM uuuu")
    isoFormat
  }
  dateFormat
  daysBookableInAdvance
  label
  placeholder
  possibleErrors {
    analytics {
      ...FlightsAnalytics
    }
    message
    type
  }
  maxStayDurationAllowed
  possibleErrorsHeader {
    icon {
      id
      description
    }
    label {
      completeText
      items {
        styles
        text
      }
    }
  }
  doneAction
}

fragment ClientMetaData on FlightsPWAMetadata {
  pageName
  pageNameAnalytics {
    ...FlightsAnalytics
  }
  responseTags
}

fragment FlightsRewardsPricingInfo on FlightsRewardsPricingInfo {
  title {
    ...FlightsResponsiveMessage
  }
  options {
    ... on FlightsRewardsOption {
      label
      identifier
      selected
      accessibility {
        ... on FlightsAccessibilityMessage {
          usage
          onCompletion
        }
      }
    }
  }
  subText {
    completeText
    delimeter
    items {
      __typename
      styles
      text
      ... on FlightsPhraseLinkNode {
        accessibility
        analytics {
          ...FlightsAnalytics
        }
        icon
        link
      }
      ... on FlightsPhraseDialogNode {
        dialog {
          __typename
          title
          message
          animation
          actions {
            ...FlightAction
          }
          displayedAnalytics {
            ...FlightsAnalytics
          }
        }
        actionableIcon {
          ... on Icon {
            id
            description
            token
          }
        }
      }
    }
  }
  loyaltyBanners {
    ...FlightsIconPlacard
  }
}

fragment PageTitle on FlightsPageTitle {
  date {
    longMessage
    shortMessage
  }
  disclaimerSubTitle {
    ...FlightsPhrase
  }
  title {
    longMessage
    shortMessage
  }
}

fragment FlightsResponsiveMessage on FlightsResponsiveMessage {
  __typename
  longMessage
  shortMessage
}

fragment FlightsPhrase on FlightsPhrase {
  completeText
  delimeter
  theme
  items {
    __typename
    text
    styles
    ... on FlightsPhraseLinkNode {
      accessibility
      analytics {
        ...FlightsAnalytics
      }
      displayAnalytics {
        ...FlightsAnalytics
      }
      scrollAnalytics {
        ...FlightsAnalytics
      }
      link
      icon
    }
    ... on FlightsPhraseDialogNode {
      accessibility
      analytics {
        ...FlightsAnalytics
      }
      actionableIcon {
        id
        description
      }
      dialog {
        __typename
        title
        message
        animation
        actions {
          ...FlightAction
        }
        displayedAnalytics {
          ...FlightsAnalytics
        }
      }
    }
  }
}

fragment FlightsIconPhrases on FlightsIconPhrases {
  text {
    ...FlightsPhrase
  }
  icon {
    ...IconSearch
  }
}

fragment AlternateAirportOptions on AlternateAirportOptions {
  accessibilityTitle
  airportOptionAnalytics {
    ...FlightsAnalytics
  }
  airportOptions {
    ...AirportOption
  }
  alternateOptionTitle
}

fragment AirportOption on AirportOption {
  accessibilityHeading
  accessibilityMessage
  destinationAirportDistance
  destinationCityName
  icon {
    ...IconSearch
  }
  originAirportDistance
  originCityName
  selectAction {
    ...FlightAction
  }
}

fragment AlternateDateOptions on AlternateDateOptions {
  accessibilityTitle
  dateOptionAnalytics {
    ...FlightsAnalytics
  }
  dateOptions {
    ...DateOption
  }
  alternateOptionTitle
}

fragment DateOption on DateOption {
  accessibilityHeading
  accessibilityMessage
  numDaysDifference
  selectAction {
    ...FlightAction
  }
  tripDates
  tripOD
}

fragment FlightsDisplayComponentCountingValue on FlightsDisplayComponentCountingValue {
  displayCount
  flightsDisplayComponent
}

fragment DateFragment on Date {
  month
  day
  year
}

fragment MultiItemPackageableProduct on MultiItemPackageableProduct {
  flights {
    offerToken
    productTokens
    travelers {
      age
      type
    }
  }
}

fragment MultiItemFlightCrossSellPrimer on MultiItemFlightCrossSellPrimer {
  __typename
  flightCrossSellProductType
  multiItemSearchContext {
    ...MultiItemSearchContext
  }
}

fragment FlightsCrossSellOffer on FlightsCrossSellOffer {
  multiItemFlightCrossSellOfferPrimer {
    multiItemSearchContext {
      ...MultiItemSearchContext
    }
    multiItemPackageableProduct {
      ...MultiItemPackageableProduct
    }
    brandedDealFallBack {
      ...MultiItemFlightCrossSellPrimer
    }
    price {
      base {
        amount
      }
      taxesAndFees {
        amount
      }
    }
  }
}

fragment FlightsFiltersEventAnalytics on FlightsFiltersEventAnalytics {
  filterAppliedEventName
  filterRemovedEventName
  eventType
  eventCategory
  pageName
}

fragment FlightsFilterItemAnalytics on FlightsFilterItemAnalytics {
  id
  position
  category
  value
  min
  max
}

fragment FlightsOfferNaturalKeysFragment on FlightsOfferNaturalKeys {
  flightNaturalKey {
    offerToken
    productTokens
    travelers {
      age
      type
    }
  }
  packagedProductsNaturalKeys {
    __typename
    ... on CarNaturalKey {
      __typename
      offerToken
    }
    ... on PropertyNaturalKey {
      __typename
      id
      ratePlanId
      roomTypeId
      inventoryType
      checkOut {
        ...DateFragment
      }
      checkIn {
        ...DateFragment
      }
      rooms {
        childAges
        numberOfAdults
      }
    }
  }
}

fragment PriceLockupFragment on EGDSPriceLockup {
  accessibilityPrice
  leadingCaption
  lockupFormattedPoints
  lockupPrice
  priceSubtextFirst
  priceSubtextBold
  priceSubtextStandard
  strikeThroughPrice
}

fragment FlightsMessagingCardPlacardFragment on FlightsMessagingCardPlacard {
  messagingCard {
    ...UIMessagingCard
  }
  button {
    primary
    clientAction {
      ...ClientActionFragment
    }
  }
  onViewedAnalytics {
    ...FlightsAnalytics
  }
  onViewedAnalyticsList {
    ...ClientSideAnalytics
  }
  actionElement {
    ...FlightsClientActionElement
  }
}

fragment FlightsClientActionElement on FlightsClientActionElement {
  ...FlightsActionLinkFragment
}

fragment EgdsGraphicIllustrationFragmentSearch on Illustration {
  link: url
  id
  description
  egdsElementId
}

fragment ClientActionFragment on FlightsDialogTriggerAction {
  dialog {
    ...EGDSFullScreenDialogFragment
  }
  dialogContents {
    ...EgdsElementFragment
  }
  analyticsList {
    __typename
    ...ClientSideAnalytics
  }
}

fragment EGDSFullScreenDialogFragment on EGDSFullScreenDialog {
  ... on EGDSFullScreenDialog {
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
}

fragment EGDSButtonFragment on EGDSButton {
  __typename
  ...FlightsActionButton
  ...FlightsDialogTriggerFragment
}

fragment FlightsDialogTriggerFragment on FlightsDialogTrigger {
  __typename
  dialogAction
  dialogId
  dynamicDialogId
  trigger {
    __typename
    ...FlightsActionButton
    ...FlightsActionLinkFragment
    ...FlightsExperienceActionButtonFragment
    ...FlightsExperienceActionLinkFragment
  }
}

fragment FlightsExperienceActionButtonFragment on FlightsExperienceActionButton {
  __typename
  accessibility
  clientAction {
    __typename
    accessibility
    analyticsList {
      ...ClientSideAnalytics
    }
    ...FlightsSelectionAction
  }
  primary
}

fragment FlightsExperienceActionLinkFragment on FlightsExperienceActionLink {
  __typename
  accessibility
  clientAction {
    __typename
    accessibility
    analyticsList {
      ...ClientSideAnalytics
    }
    ...FlightsSelectionAction
  }
  primary
}

fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {
  title
  closeText
}

fragment EgdsElementFragment on EGDSElement {
  __typename
  ... on EGDSText {
    ...EgdsTextFragment
  }
  ... on Illustration {
    ...EgdsGraphicIllustrationFragmentSearch
  }
  ... on UIMessagingCard {
    primary
    secondaries
    graphic {
      __typename
      ... on Illustration {
        link: url
      }
      ...EgdsGraphicIllustrationFragmentSearch
    }
  }
  ... on EGDSBulletedList {
    listItems {
      __typename
      text
    }
  }
}

fragment EgdsTextFragment on EGDSText {
  __typename
  ... on EGDSGraphicText {
    ...EGDSGraphicTextFragment
  }
  ... on EGDSHeading {
    text
    headingType
  }
  ... on EGDSParagraph {
    text
    style
  }
  ... on EGDSIconText {
    text
    icon {
      id
      size
    }
  }
  ... on EGDSStandardLink {
    text
    action {
      __typename
      accessibility
      target
      resource {
        __typename
        value
      }
      analytics {
        __typename
        linkName
        referrerId
      }
    }
  }
  ... on EGDSPlainText {
    text
  }
  ... on EGDSStylizedText {
    decorative
    text
    theme
    weight
    stylizedSize: size
  }
  ... on EGDSSpannableText {
    ...EGDSSpannableTextFragment
  }
}

fragment FaresDialogsFragment on FlightsDialog {
  dialog {
    __typename
    ...EGDSDialogFragment
  }
  dialogContent: content {
    __typename
    ...EgdsElementFragment
    ... on FlightsDialogTrigger {
      ...FlightsDialogTriggerFragment
    }
  }
  dialogId
  dynamicDialogId
}

fragment EGDSDialogFragment on EGDSDialog {
  closeAnalytics {
    ...ClientSideAnalytics
  }
  ...EGDSFullScreenDialogFragment
  ... on EGDSActionDialog {
    __typename
    footer {
      __typename
      buttons {
        ...EGDSButtonFragment
      }
    }
  }
}

fragment FlightsActionCheckboxFragment on FlightsActionCheckbox {
  label {
    ...EgdsTextFragment
  }
  clientAction {
    ...FlightsClickActionFragment
  }
}

fragment FlightsActionLinkFragment on FlightsActionLink {
  __typename
  clientAction {
    ...FlightsClientActionFragment
  }
  disabled
  primary
  icon {
    ...IconSearch
  }
  analytics {
    ...ClientSideAnalytics
  }
}

fragment FlightsClientActionFragment on FlightsClientAction {
  accessibility
  analyticsList {
    ...ClientSideAnalytics
  }
  ... on FlightsCreditSelectionAction {
    originalBookingId
  }
  ...FlightsBoundNavigation
  ...FlightsNavigateToDetails
  ...FlightsResourceLinkAction
  ...FlightsSelectionAction
  ...MultiItemSelectPackage
  ...MultiItemSelectProducts
}

fragment FlightsClickActionFragment on FlightsClickAction {
  __typename
  analyticsList {
    __typename
    ...ClientSideAnalytics
  }
  accessibility
}

fragment FlightsMessagingCardFragment on FlightsMessagingCard {
  cardContent {
    ...EGDSStandardMessagingCardFragment
  }
  displayAnalytics {
    ...ClientSideAnalytics
  }
}

fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {
  dismiss {
    ...EGDSDismissActionFragment
  }
  egdsElementId
  graphic {
    ...UIGraphicFragment
  }
  heading
  links {
    ...EGDSStandardLinkFragment
  }
  message
  rightIcon {
    ...IconSearch
  }
}

fragment EGDSDismissActionFragment on EGDSDismissAction {
  accessibility
  analytics {
    ...ClientSideAnalytics
  }
  label
}

fragment UIGraphicFragment on UIGraphic {
  ...IconSearch
  ...MarkFragments
  ...EgdsGraphicIllustrationFragmentSearch
}

fragment EGDSStandardLinkFragment on EGDSStandardLink {
  action {
    ...UILinkActionFragment
  }
  disabled
  icon {
    ...IconSearch
  }
  iconPosition
  size
  text
}

fragment UILinkActionFragment on UILinkAction {
  accessibility
  analytics {
    ...ClientSideAnalytics
  }
  resource {
    value
  }
  target
  useRelativePath
}

fragment FlightsListingMessagingCard on FlightsListingMessagingCard {
  messagingCard {
    ...FlightsMessagingCardPlacardFragment
  }
}

fragment FlightsOfferSponsoredUpsell on FlightsOfferSponsoredUpsell {
  __typename
  badge {
    ...EGDSBadgeFragment
  }
  expando {
    ...EGDSExpandoFragment
  }
  details {
    ...FlightsSponsoredUpsellDetails
  }
  action {
    ...FlightsDialogTriggerFragment
  }
  onViewedAnalytics {
    ...ClientSideAnalytics
  }
  sponsoredFareAnalyticsList {
    ...ClientSideAnalytics
  }
}

fragment FlightsSponsoredUpsellDetails on FlightsSponsoredFareInformation {
  __typename
  mediaSection {
    badge {
      ...EGDSBadgeFragment
    }
    featureImage {
      url
      description
      thumbnailClickAnalytics {
        ...ClientSideAnalytics
      }
    }
  }
  heading {
    __typename
    accessibility
    text
  }
  description
  bulletpoints {
    __typename
    listItems {
      __typename
      text
    }
  }
  priceLockup {
    ...PriceLockupFragment
  }
  onViewedAnalytics {
    ...ClientSideAnalytics
  }
  sponsoredFareAnalyticsList {
    ...ClientSideAnalytics
  }
  onClickAnalyticsList {
    ...ClientSideAnalytics
  }
}

fragment EGDSGraphicTextFragment on EGDSGraphicText {
  textGraphic: graphic {
    ...UIGraphicFragment
  }
  text
}

    `;

    export const flightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchResultsGreedyFetchLoading(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $shoppingContext: ShoppingContextInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
    shoppingContext: $shoppingContext
  ) {
    listingResult {
      ... on FlightsLoadingListingResult {
        listingsSkeletonCount
      }
    }
  }
}

    `;

    export const flightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $shoppingContext: ShoppingContextInput
  $flightsSearchComponentCriteria: FlightsSearchComponentCriteriaInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
    shoppingContext: $shoppingContext
    flightsSearchComponentCriteria: $flightsSearchComponentCriteria
  ) {
    clientMetadata {
      ... on FlightsPWAMetadata {
        pageName
        pageNameAnalytics {
          ...FlightsAnalytics
        }
      }
    }
    pageTitle {
      date {
        longMessage
        shortMessage
      }
      disclaimerSubTitle {
        ...FlightsPhraseLoading
      }
      title {
        longMessage
        shortMessage
      }
    }
    listingResult {
      ... on FlightsLoadingListingResult {
        listingsSkeletonCount
        message
        originDestination
        progressBarDetails {
          accessibility {
            initialValue
            template
            tokens
          }
          accessibilityMessage
          listingsLatency
          sortAndFilterLatency
        }
        progressBar
        paginationConfig {
          faresSeparationType
          pagination {
            size
            startingIndex
          }
        }
      }
    }
    sortAndFilterResult {
      ... on FlightsLoadingSortAndFilterResult {
        filterPresentation {
          __typename
          options {
            __typename
            itemCount
            label
            priceFromLabel
          }
          title
        }
        revealAction {
          iconAndLabel {
            icon {
              id
            }
            label
          }
          enabled
        }
      }
    }
    searchForm {
      __typename
      ... on FlightsLoadingSearchForm {
        addJourneyAction {
          displayAction
          displayType
        }
        bookingChangeLink {
          ...FlightsResourceLinkAction
        }
        departureAndReturnDates {
          longMessage
          shortMessage
        }
        journeys {
          departureDate {
            date {
              isoFormat
            }
            label
            placeholder
          }
          label {
            initialValue
            template
            tokens
          }
          destinationLocation {
            icon {
              id
            }
            label
            placeholder
            value
            airportCode
          }
          originLocation {
            icon {
              id
            }
            label
            placeholder
            value
            airportCode
          }
          returnDate {
            date {
              isoFormat
            }
            label
            placeholder
          }
          removeJourneyAction {
            displayAction
          }
          swapLocationsAction {
            icon {
              smallView {
                id
                size
              }
              largeView {
                id
                size
              }
            }
          }
        }
        originAndDestinationLocations
        searchAction
        searchOptions {
          ... on FlightsSearchFormAirlineOption {
            __typename
            label
            icon {
              id
            }
            selectedItem {
              airline
              label
            }
          }
          ... on FlightsSearchFormCabinClassOption {
            __typename
            label
            icon {
              id
            }
            selectedItem {
              cabinClass
              label
            }
          }
          ... on FlightsSearchFormMoreFiltersOption {
            __typename
            label
            icon {
              id
            }
          }
          ... on FlightsSearchFormTravelersOption {
            __typename
            label
            icon {
              id
            }
            valueTemplate {
              oneTemplate
              manyTemplate
              tokens
              fewTemplate
              otherTemplate
              twoTemplate
              zeroTemplate
            }
            items {
              __typename
              label
              travelerCount
              type
            }
          }
          ... on FlightsSearchFormTripTypeOption {
            __typename
            icon {
              id
            }
            items {
              label
              selected
              tripType
            }
          }
        }
        airportDropdownEnabled
        availableRoutes {
          destinationsString
          originString
          originCountries {
            countryName
            origins {
              airportName
              airportCode
              destinationCountries {
                countryName
                destinations {
                  airportName
                  airportCode
                }
              }
            }
          }
        }
      }
    }
    flexibleSearchResponse {
      title
      subTitle
      titleAccessibility
      searchTriggerAction
      flexGridType
      loadingStateAccessibility
    }
    failedRequestMessaging {
      icon {
        id
      }
      message
      action {
        analytics {
          ...FlightsAnalytics
        }
        displayAction
      }
      errorRecoveryButtons {
        analytics {
          ...FlightsAnalytics
        }
        displayAction
      }
    }
    gaiaId
    stepIndicator {
      ...FlightsStepIndicatorLoading
    }
    shoppingContext {
      multiItem {
        id
        packageType
      }
    }
    journeysContinuationId
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment FlightsStepIndicatorLoading on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalytics
  }
  journeyContinuationId
}

fragment FlightsPhraseLoading on FlightsPhrase {
  completeText
  delimeter
  items {
    __typename
    text
    styles
    ... on FlightsPhraseLinkNode {
      accessibility
      analytics {
        ...FlightsAnalytics
      }
      displayAnalytics {
        ...FlightsAnalytics
      }
      link
      icon
    }
  }
}

fragment ClientSideAnalytics on ClientSideAnalytics {
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment HttpURI on HttpURI {
  __typename
  relativePath
  value
}

fragment FlightsResourceLinkAction on FlightsResourceLinkAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalytics
  }
  resource {
    ...HttpURI
  }
}

    `;

    export const flightSearchResultsOnClientLoadingQuery = templateJoin`
        query FlightSearchResultsOnClientLoading(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $shoppingContext: ShoppingContextInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
    shoppingContext: $shoppingContext
  ) {
    stepIndicator {
      ...FlightsStepIndicatorOnClientLoading
    }
    flexibleSearchResponse {
      title
      subTitle
      titleAccessibility
      flexGridType
      loadingStateAccessibility
    }
    shoppingContext {
      multiItem {
        id
        packageType
      }
    }
  }
}

fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}

fragment FlightsStepIndicatorOnClientLoading on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalytics
  }
  journeyContinuationId
}

    `;

    export const flightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery = templateJoin`
        query FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearch(
  $context: ContextInput!
  $flightsSearchContext: FlightsSearchContextInput
  $journeyCriteria: [FlightsJourneyCriteriaInput!]!
  $queryState: FlightsQueryState
  $searchFilterValuesList: [FlightsSearchFilterValuesInput!]
  $searchPreferences: FlightsSearchPreferencesInput
  $sortOption: FlightsSortOptionTypeInput
  $travelerDetails: [FlightsTravelerDetailsInput!]
  $searchPagination: PaginationInput
  $faresSeparationType: FlightsFaresSeparationType
  $shoppingContext: ShoppingContextInput
) {
  flightsSearch(
    context: $context
    flightsSearchContext: $flightsSearchContext
    journeyCriteria: $journeyCriteria
    queryState: $queryState
    searchFilterValuesList: $searchFilterValuesList
    searchPreferences: $searchPreferences
    sortOption: $sortOption
    travelerDetails: $travelerDetails
    searchPagination: $searchPagination
    faresSeparationType: $faresSeparationType
    shoppingContext: $shoppingContext
  ) {
    availableFares {
      journeyContinuationId
      flightsJourneyAvailableFaresInformation {
        ...FlightsJourneyAvailableFaresUpsell
      }
    }
    shoppingContext {
      multiItem {
        id
        packageType
      }
    }
  }
}

fragment FlightsToggleSearchUpsell on FlightsToggle {
  __typename
  collapseActionable {
    ...TogglePhaseSearchUpsell
  }
  expandActionable {
    ...TogglePhaseSearchUpsell
  }
  expanded
}
fragment IconSearchUpsell on Icon {
  __typename
  description
  id
  size
  theme
  withBackground
}
fragment TogglePhaseSearchUpsell on TogglePhase {
  accessibilityMessage
  action
  analytics {
    ...FlightsAnalytics
  }
  icon {
    ...IconSearchUpsell
  }
}
fragment FlightsAnalytics on FlightsAnalytics {
  __typename
  linkName
  referrerId
}
fragment FlightActionUpsell on FlightsAction {
  __typename
  accessibilityMessage
  analytics {
    ...FlightsAnalytics
  }
  analyticsList {
    ...FlightsAnalytics
  }
  displayAnalytics {
    ...FlightsAnalytics
  }
  displayAction
  displayType
  journeySearchCriteria {
    previousFlightSelections {
      journeyIndex
      offerIdentifier
    }
  }
  relativeURI {
    relativePath
    value
  }
  relativePackageableURI {
    relativePath
    value
  }
  stepIndicator {
    ...FlightsStepIndicatorUpsell
  }
  searchPagination {
    ...PaginationUpsell
  }
  type
}
fragment FlightsStepIndicatorUpsell on FlightsStepIndicator {
  errorAnalytics {
    ...FlightsAnalytics
  }
  journeyContinuationId
}
fragment CoordinateInformationSearchUpsell on CoordinateInformation {
  icon {
    ...IconSearchUpsell
  }
  flightDetailsWarningInfo {
    __typename
    icon {
      ...IconSearchUpsell
    }
    label
    theme
    accessibility
    value
    displayAnalytics {
      ...FlightsAnalytics
    }
  }
  subtitle
  titleAndAccessibilityMessage {
    accessibilityMessage
    text
  }
}
fragment FlightsJourneyAvailableFaresUpsell on FlightsJourneyAvailableFares {
  __typename
  applySelection {
    ...FlightActionUpsell
  }
  dismissDetailedJourneyInformation {
    ...FlightsActionableIconUpsell
  }
  fareChoiceInformation {
    __typename
    accessibleHeading
    availableFaresCount
    defaultBaggageInformation {
      bagFeesMoreInfo {
        __typename
        completeText
        delimeter
        items {
          styles
          text
          ... on FlightsPhraseLinkNode {
            accessibility
            analytics {
              ...FlightsAnalytics
            }
            icon
            link
          }
        }
      }
      defaultBagSelectionMessage
      details {
        baggageDetail
        topic
      }
      dismissAction
      displayDetailsAction
      label
    }
    displayAnalytics {
      ...FlightsAnalytics
    }
    errorAnalytics {
      ...FlightsAnalytics
    }
    scrollAnalytics {
      ...FlightsAnalytics
    }
    convertAnalytics {
      ...FlightsAnalytics
    }
    fares {
      __typename
      accessibilityMessage
      safetyLocationAccessibilityMessage
      selectFareActionAltText
      multiItemPriceToken
      multiItemAction {
        __typename
        ... on MultiItemSelectPackageAction {
          packageOfferId
        }
        ... on MultiItemSelectProductsAction {
          multiItemSessionId
          flightsOfferNaturalKeys {
            ...FlightsOfferNaturalKeys
          }
          multiItemPriceToken
        }
      }
      flightsOfferNaturalKeys {
        ...FlightsOfferNaturalKeys
      }
      baggageFeesInformation {
        __typename
        bagFeesMoreInfo {
          __typename
          completeText
          delimeter
          items {
            __typename
            styles
            text
            ... on FlightsPhraseLinkNode {
              accessibility
              analytics {
                ...FlightsAnalytics
              }
              icon
              link
            }
          }
        }
        defaultBagSelectionMessage
        details {
          __typename
          baggageDetail
          topic
        }
        displayDetailsAction
        dismissAction
        label
      }
      cabinClass
      cabinClassAndBookingCodes
      selectFareAction {
        ...FlightActionUpsell
      }
      clickEventAnalytics {
        ...FlightsAnalytics
      }
      collapsedRules {
        ...FlightsJourneyAmenitiesUpsell
      }
      expandedRules {
        ...FlightsJourneyAmenitiesWithLabelUpsell
      }
      amenityHierarchyRules {
        ...FlightsJourneyAmenitiesWithLabelUpsell
      }
      amenityRules {
        __typename
        itemsDefaultDisplayCount
        amenities {
          __typename
          accessibility
          icon {
            ...IconSearchUpsell
          }
          label
          theme
        }
      }
      changeCancellationMessages {
        __typename
        displayAnalyticsList {
          ...FlightsAnalytics
        }
        heading
        messages {
          ...FlightsPhraseUpsell
        }
      }
      chooseFareAction {
        __typename
        accessibilityMessage
        displayAction
        type
      }
      fareScrollAnalytics {
        ...FlightsAnalytics
      }
      formattedPrice {
        __typename
        completeText
        items {
          text
          styles
        }
      }
      formattedMainPrice {
        completeText
        items {
          text
          styles
        }
      }
      identifier
      name
      recommendation {
        ...FlightsBadgeUpsell
      }
      selected
      showMoreAmenitiesToggle {
        ...FlightsToggleSearchUpsell
      }
      totalPrice
      priceAccessibilityMessage
      journeyFareTotalPrice
      upsellOfferToken
      badges {
        accessibility
        text
        theme
      }
      priceLockup {
        accessibilityPrice
        lockupPrice
        strikeThroughPrice
        priceSubtextFirst
      }
      ... on FlightsPMPJourneyFare {
        isPmpSelected
        priceLockupWithPMP {
          accessibilityPrice
          lockupPrice
          strikeThroughPrice
          priceSubtextFirst
        }
        selectFareActionWithPMP {
          ...FlightActionUpsell
        }
        priceMatchPromiseSelectionCardSection {
          ...PriceMatchPromiseSelectionFragment
        }
        priceMatchPromiseSelectedCardSection {
          ...PriceMatchPromiseSelectedFragment
        }
      }
    }
    heading {
      ...FlightsResponsiveMessageUpsell
    }
    message
    nextFareChoiceAccessibilityMessage
    previousFareChoiceAccessibilityMessage
    tripTypePerTraveler
    faresTypesLoadingAnalytics {
      faresLoadErrorAnalytics {
        ...FlightsAnalytics
      }
      faresLoadingDisplayedAnalytics {
        ...FlightsAnalytics
      }
      faresLoadingTimeAnalytics {
        ...FlightsAnalytics
      }
      continueButtonOnClickAnalytics {
        ...FlightsAnalytics
      }
    }
    percentageDelaysAndCancellationLink {
      __typename
      analytics {
        ...FlightsAnalytics
      }
      displayAction
      url
      accessibility
    }
    sustainabilityInformation {
      ...FlightsIconUpsellPhrases
    }
    dialogs {
      ...FaresDialogs
    }
  }
  flightsJourneyHeaders {
    flightsJourneySubheadingMark {
      description
      id
      size
      token
      url {
        relativePath
        value
      }
    }
    flightsJourneySubheading
    heading
  }
  flightsJourneyInformation {
    ...FlightsJourneyInformationUpsell
  }
  flightsJourneyPolicies {
    messages {
      completeText
      items {
        text
        styles
      }
    }
  }
  flightsJourneySummary {
    __typename
    heading {
      __typename
      accessibilityMessage
      text
    }
    differentDayArrival {
      __typename
      accessibilityMessage
      text
    }
    basicFlightDetails {
      __typename
      accessibilityMessage
      text
    }
    ... on FlightsBargainJourneySummary {
      arrivalDayInformation
      formattedPrice {
        completeText
        items {
          styles
          text
        }
      }
      tripTypePerTraveler
      totalPrice
    }
  }
  openAccessibility
}
fragment FlightsJourneyAmenitiesUpsell on FlightsJourneyAmenities {
  accessibilityMessage
  amenities {
    icon {
      ...IconSearchUpsell
    }
    label
    subLabel
    theme
    accessibility
    value
    displayAnalytics {
      ...FlightsAnalytics
    }
  }
  analytics {
    ...FlightsAnalytics
  }
}
fragment FlightsJourneyAmenitiesWithLabelUpsell on FlightsJourneyAmenitiesWithLabel {
  label
  rules {
    ...FlightsJourneyAmenitiesUpsell
  }
}
fragment PaginationUpsell on Pagination {
  size
  startingIndex
}
fragment FlightsJourneyInformationUpsell on FlightsDetailedJourneyInformation {
  __typename
  details {
    ...FlightsToggleSearchUpsell
  }
  flightJourneyDetails {
    __typename
    journeySections {
      journeyConnectionInformation {
        __typename
        ... on AdditionalInformation {
          durationAndStop
          nextFlightOriginAirportInfo {
            __typename
            icon {
              ...IconSearchUpsell
            }
            label
            theme
            accessibility
          }
        }
        ... on FlightsConnectionInformation {
          flightsConnection {
            aircraftModel
            airlineInfo
            cabinClassAndBookingCode
            connectionArrival {
              ...CoordinateInformationSearchUpsell
            }
            connectionDeparture {
              ...CoordinateInformationSearchUpsell
            }
            duration
            journeyAmenities {
              ...FlightsJourneyAmenitiesUpsell
            }
            operatedBy
          }
        }
      }
    }
  }
}

fragment FlightsBadgeUpsell on FlightsBadge {
  __typename
  accessibilityMessage
  icon {
    id
    description
  }
  text
  type
}
fragment FlightsActionableIconUpsell on FlightsActionableIcon {
  __typename
  icon {
    ...IconSearchUpsell
  }
  analytics {
    ...FlightsAnalytics
  }
}
fragment FlightsResponsiveMessageUpsell on FlightsResponsiveMessage {
  __typename
  longMessage
  shortMessage
}

fragment DateFragmentUpsell on Date {
  month
  day
  year
}

fragment FlightsIconUpsellPhrases on FlightsIconPhrases {
  text {
    ...FlightsPhraseUpsell
  }
  icon {
    ...IconSearchUpsell
  }
}

fragment FlightsOfferNaturalKeys on FlightsOfferNaturalKeys {
  flightNaturalKey {
    offerToken
    productTokens
    travelers {
      age
      type
    }
  }
  packagedProductsNaturalKeys {
    __typename
    ... on CarNaturalKey {
      __typename
      offerToken
    }
    ... on PropertyNaturalKey {
      __typename
      id
      ratePlanId
      roomTypeId
      inventoryType
      checkOut {
        ...DateFragmentUpsell
      }
      checkIn {
        ...DateFragmentUpsell
      }
      rooms {
        childAges
        numberOfAdults
      }
    }
  }
}

fragment FlightsPhraseUpsell on FlightsPhrase {
  completeText
  delimeter
  items {
    __typename
    text
    styles
    ... on FlightsPhraseLinkNode {
      accessibility
      analytics {
        ...FlightsAnalytics
      }
      displayAnalytics {
        ...FlightsAnalytics
      }
      scrollAnalytics {
        ...FlightsAnalytics
      }
      link
      icon
    }
  }
}

fragment EGDSButton on EGDSButton {
  __typename
  ...FlightsActionButtonUpsell
  ...FlightsDialogTrigger
}

fragment FlightsDialogTrigger on FlightsDialogTrigger {
  __typename
  dialogAction
  dialogId
  trigger {
    __typename
    ...FlightsActionButtonUpsell
    ...FlightsActionLink
  }
}

fragment FaresDialogs on FlightsDialog {
  dialog {
    __typename
    ...EGDSDialog
  }
  dialogContent: content {
    __typename
    ...EgdsElementFragmentUpsell
    ... on FlightsDialogTrigger {
      ...FlightsDialogTrigger
    }
  }
  dialogId
}

fragment EGDSDialog on EGDSDialog {
  closeAnalytics {
    ...ClientSideAnalyticsUpsell
  }
  ...EGDSFullScreenDialogFragmentUpsell
  ... on EGDSActionDialog {
    __typename
    footer {
      __typename
      buttons {
        ...EGDSButton
      }
    }
  }
}

fragment PriceMatchPromiseSelectionFragment on PriceMatchPromiseSelectionCardSection {
  header
  description
  price
  icon {
    ...IconSearchUpsell
  }
  toggleCheckbox {
    label {
      ...EgdsTextFragmentUpsell
    }
    clientAction {
      ...FlightsClickActionUpsellFragment
    }
  }
  onDisplayAnalytics {
    ...FlightsAnalytics
  }
  infoTrigger {
    ...FlightsDialogTrigger
  }
}

fragment PriceMatchPromiseSelectedFragment on PriceMatchPromiseSelectedCardSection {
  header
  description
  icon {
    ...IconSearchUpsell
  }
  removeActionLink {
    ...FlightsActionLink
  }
  onDisplayAnalytics {
    ...FlightsAnalytics
  }
}

fragment FlightsActionLink on FlightsActionLink {
  clientAction {
    accessibility
    analyticsList {
      ...ClientSideAnalyticsUpsell
    }
    ... on FlightsCreditSelectionAction {
      originalBookingId
    }
    ... on FlightsResourceLinkAction {
      resource {
        ... on HttpURI {
          relativePath
          value
        }
      }
    }
  }
  disabled
  primary
  icon {
    ...IconSearchUpsell
  }
}

fragment EgdsElementFragmentUpsell on EGDSElement {
  __typename
  ... on EGDSText {
    ...EgdsTextFragmentUpsell
  }
  ... on Illustration {
    ...EgdsGraphicIllustrationFragment
  }
  ... on UIMessagingCard {
    primary
    secondaries
    graphic {
      __typename
      ... on Illustration {
        link: url
      }
      ...EgdsGraphicIllustrationFragment
    }
  }
  ... on EGDSBulletedList {
    listItems {
      __typename
      text
    }
  }
}

fragment EgdsTextFragmentUpsell on EGDSText {
  __typename
  ... on EGDSGraphicText {
    ...EGDSGraphicTextFragmentUpsell
  }
  ... on EGDSHeading {
    text
    headingType
  }
  ... on EGDSParagraph {
    text
    style
  }
  ... on EGDSIconText {
    text
    icon {
      id
      size
    }
  }
  ... on EGDSStandardLink {
    text
    action {
      __typename
      accessibility
      target
      resource {
        __typename
        value
      }
      analytics {
        __typename
        linkName
        referrerId
      }
    }
  }
  ... on EGDSPlainText {
    text
  }
  ... on EGDSStylizedText {
    decorative
    text
    theme
    weight
    stylizedSize: size
  }

  ... on EGDSSpannableText {
    ...EGDSSpannableTextFragmentUpsell
  }
}

fragment EgdsGraphicIllustrationFragment on Illustration {
  link: url
  id
  description
}

fragment FlightsActionButtonUpsell on FlightsActionButton {
  __typename
  accessibility
  clientAction {
    __typename
    analyticsList {
      ...ClientSideAnalyticsUpsell
    }
    ...FlightsResourceLinkActionUpsell
    ...FlightsCreditSelectorOpenActionUpsell
  }
  disabled
  egdsElementId
  icon {
    ...IconSearchUpsell
  }
  primary
  style
  buttonStyle: style
  action {
    __typename
    accessibility
    analytics {
      ...ClientSideAnalyticsUpsell
    }
  }
}

fragment FlightsCreditSelectorOpenActionUpsell on FlightsCreditSelectorOpenAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalyticsUpsell
  }
}

fragment ClientSideAnalyticsUpsell on ClientSideAnalytics {
  linkName
  referrerId
  uisPrimeMessages {
    messageContent
    schemaName
  }
}

fragment EGDSFullScreenDialogFragmentUpsell on EGDSFullScreenDialog {
  ... on EGDSFullScreenDialog {
    toolbar {
      title
      closeText
    }
  }
}

fragment FlightsResourceLinkActionUpsell on FlightsResourceLinkAction {
  __typename
  accessibility
  analyticsList {
    ...ClientSideAnalyticsUpsell
  }
  resource {
    ...HttpURI
  }
}

fragment HttpURI on HttpURI {
  __typename
  relativePath
  value
}

fragment FlightsClickActionUpsellFragment on FlightsClickAction {
  __typename
  analyticsList {
    __typename
    ...ClientSideAnalyticsUpsell
  }
  accessibility
}

fragment EGDSSpannableTextFragmentUpsell on EGDSSpannableText {
  __typename
  text
  contents {
    __typename
    ... on EGDSHeading {
      text
      headingType
    }
    ... on EGDSParagraph {
      text
      style
    }
    ... on EGDSIconText {
      text
      icon {
        id
        size
      }
    }
    ... on EGDSStandardLink {
      text
      action {
        __typename
        accessibility
        target
        resource {
          __typename
          value
        }
        analytics {
          __typename
          linkName
          referrerId
        }
      }
    }
    ... on EGDSPlainText {
      text
    }
    ... on EGDSStylizedText {
      decorative
      text
      theme
      weight
      stylizedSize: size
    }
  }
  inlineContent {
    __typename
    ... on EGDSHeading {
      text
      headingType
    }
    ... on EGDSGraphicText {
      ...EGDSGraphicTextFragmentUpsell
    }
    ... on EGDSStandardLink {
      text
      action {
        __typename
        accessibility
        target
        resource {
          __typename
          value
        }
        analytics {
          __typename
          linkName
          referrerId
        }
      }
    }
    ... on EGDSPlainText {
      text
    }
    ... on EGDSStylizedText {
      decorative
      text
      theme
      weight
      stylizedSize: size
    }
  }
}

fragment MarkFragments on Mark {
  __typename
  description
  id
  markSize: size
  url {
    ... on HttpURI {
      __typename
      relativePath
      value
    }
  }
}

fragment EGDSGraphicTextFragmentUpsell on EGDSGraphicText {
  textGraphic: graphic {
    ...UIGraphicFragmentUpsell
  }
  text
}

fragment UIGraphicFragmentUpsell on UIGraphic {
  ...IconSearchUpsell
  ...MarkFragments
  ...EgdsGraphicIllustrationFragment
}

    `;

    export const selectPackageQuery = templateJoin`
        mutation SelectPackage($context: ContextInput!, $packageOfferId: String!, $sessionId: String!) {
  multiItemShopping(context: $context) {
    selectPackage(packageOfferId: $packageOfferId, sessionId: $sessionId) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        action {
          shoppingContext {
            multiItem {
              id
              packageType
            }
          }
        }
        redirectUrl
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}

    `;

    export const selectProductsQuery = templateJoin`
        mutation SelectProducts(
  $context: ContextInput!
  $sessionId: String!
  $priceToken: String
  $properties: [PropertyNaturalKeyInput!]
  $flights: [FlightNaturalKeyInput!]
  $cars: [CarNaturalKeyInput!]
) {
  multiItemShopping(context: $context) {
    selectProducts(
      sessionId: $sessionId
      priceToken: $priceToken
      properties: $properties
      flights: $flights
      cars: $cars
    ) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        shoppingContext {
          multiItem {
            id
            packageType
          }
        }
        redirectUrl
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}

    `;

    export const virtualAgentFlightCheckoutQuery = templateJoin`
        mutation VirtualAgentFlightCheckout(
  $context: ContextInput!
  $flightsDetailsCriteria: FlightsDetailCriteriaInput!
  $virtualAgentContext: VirtualAgentContextInput!
) {
  virtualAgentFlightCheckout(
    context: $context
    flightsDetailsCriteria: $flightsDetailsCriteria
    virtualAgentContext: $virtualAgentContext
  ) {
    status
  }
}

    `;

